{
  "app": {
    "shellTitle": "TMM Product Admin · Consola de Plataforma",
    "loading": "Cargando",
    "name": "TMM Product Admin"
  },
  "common": {
    "retry": "Reintentar",
    "close": "Cerrar",
    "menu": "Menú",
    "loading": "Cargando",
    "loadingPage": "Cargando…",
    "language": "Idioma",
    "noProgress": "Sin progreso",
    "days_one": "{{count, number}} día",
    "days_other": "{{count, number}} días",
    "unlimited": "∞",
    "panelError": "No se pudo mostrar esta sección.",
    "tryAgain": "Reintentar",
    "outcomeUnknown": "No pudimos confirmar el cambio. La pantalla se ha recargado: compruébalo antes de volver a intentarlo.",
    "cancel": "Cancelar",
    "scope": {
      "period": "{{period}} ({{from}} – {{to}}) · {{reseller}}"
    },
    "loadedAt": "Cargado a las {{time}}",
    "reload": "Recargar",
    "confirm": "Confirmar"
  },
  "components": {
    "saving": "Guardando…",
    "cannotClear": "Esto aún no se puede borrar. Introduce un valor o déjalo como estaba.",
    "copy": "Copiar {{identifier}}",
    "copied": "Copiado",
    "lastAttemptFailed": "El último intento falló.",
    "copyDetails": "Copiar detalles para soporte",
    "idLabel": "ID {{id}}",
    "reference": "Referencia: {{id}}",
    "loadFailed": "No se pudo cargar.",
    "clearFilters": "Borrar filtros",
    "filteredEmpty": "Hay un filtro activo. Bórralo para ver todo.",
    "moreActions": "Más acciones",
    "actionsFor": "Acciones para {{name}}",
    "editDetails": {
      "menu": "Editar detalles…",
      "title": "Editar detalles",
      "saved": "Detalles guardados.",
      "refreshFailed": "Guardado. No se pudo actualizar",
      "nameTaken": "Ese nombre ya está en uso.",
      "immutable": "{{fields}} no se pueden cambiar en un {{entity}} en vigor. Usa Copiar para cambiar.",
      "conflict": "Otra persona cambió esto. Recarga para ver sus cambios.",
      "reload": "Recargar",
      "save": "Guardar",
      "futureOffers": "Se aplica solo a ofertas futuras.",
      "required": "Obligatorio.",
      "tooLong": "Como máximo {{max, number}} caracteres.",
      "entity": {
        "commissionPlan": "plan de comisiones",
        "agreement": "acuerdo",
        "addon": "complemento",
        "reseller": "revendedor"
      },
      "saveError": "No se pudieron guardar los detalles."
    },
    "breadcrumbs": "Ruta de navegación",
    "copyFailed": "No se pudo copiar: selecciona el texto.",
    "unsaved": {
      "title": "¿Salir sin guardar?",
      "consequence": "Se perderán tus cambios en {{name}}.",
      "leave": "Salir",
      "stay": "Quedarme"
    },
    "errorSummary_one": "{{count, number}} campo necesita atención",
    "errorSummary_other": "{{count, number}} campos necesitan atención"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "nav": {
    "signOut": "Cerrar sesión",
    "dashboard": "Panel",
    "group": {
      "platform": "Plataforma",
      "pricing": "Precios",
      "money": "Dinero"
    },
    "rateCards": "Tarifarios",
    "addOns": "Catálogo de complementos",
    "revenue": "Ingresos",
    "payouts": "Pagos",
    "aiModelPrices": "Precios de modelos de IA",
    "settings": "Configuración",
    "partners": "Socios",
    "tickets": "Soporte",
    "parkedPayments": "Cobros en espera",
    "billingAttention": "Atención de facturación",
    "aiCostReconciliation": "Conciliación de costos de IA",
    "merchantKnowledge": "Conocimiento de comercios"
  },
  "shell": {
    "scope": "Plataforma — todos los tenants",
    "accountMenu": "Cuenta",
    "collapseNav": "Contraer navegación",
    "expandNav": "Expandir navegación",
    "theme": {
      "label": "Tema",
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Sistema"
    },
    "skipToMain": "Saltar al contenido principal"
  },
  "palette": {
    "trigger": "Buscar o ir a…",
    "triggerLabel": "Buscar o ir a… ({{shortcut}})",
    "keysHint": "↑↓ para moverse · Intro para abrir · Esc para cerrar",
    "resultCount_one": "{{count, number}} resultado",
    "resultCount_other": "{{count, number}} resultados",
    "noMatches": "Sin coincidencias para \"{{q}}\"",
    "recentGone": "Ese registro ya no existe.",
    "group": {
      "recent": "Vistos recientemente",
      "commands": "Comandos",
      "screens": "Pantallas",
      "nextSteps": "Siguientes pasos"
    },
    "command": {
      "newRateCard": "Nuevo tarifario",
      "theme": "Tema: {{mode}}"
    },
    "type": {
      "affiliate": "Afiliado"
    },
    "failed": {},
    "searching": {}
  },
  "page": {
    "dashboard": {
      "title": "Panel",
      "subtitle": "Cada tenant de la plataforma, lo que cobró y lo que retenemos."
    },
    "rateCards": {
      "title": "Tarifarios"
    },
    "addOns": {
      "title": "Catálogo de complementos",
      "subtitle": "Lo que la plataforma vende a los tenants, y quién lo tiene."
    },
    "revenue": {
      "title": "Ingresos",
      "subtitle": "Lo que cobró la flota, nuestro precio mayorista y el margen y neto de cada revendedor."
    },
    "payouts": {
      "title": "Pagos",
      "subtitle": "Una hoja de ejecución para revendedores y afiliados de todos los tenants."
    },
    "aiModelPrices": {
      "title": "Precios de modelos de IA",
      "subtitle": "Lo que nos cuestan los modelos y los límites de IA de la plataforma."
    },
    "settings": {
      "subtitle": "Configuración de toda la plataforma para este producto.",
      "title": "Configuración del producto"
    },
    "partners": {
      "title": "Socios"
    },
    "billingAttention": {
      "title": "Atención de facturación",
      "subtitle": "Problemas de facturación que hay que mirar. Cada pestaña es un tipo."
    },
    "parkedEvents": {
      "title": "Eventos de cobro en espera",
      "subtitle": "Eventos de cobro que tmm-api no pudo aplicar. Vuelve a aplicar uno cuando se corrija la causa, o descártalo."
    },
    "aiReconciliation": {
      "title": "Conciliación de costos de IA",
      "subtitle": "Una fila por día UTC y moneda. Los recuentos resaltados deben ser cero."
    },
    "resellers": {},
    "tickets": {
      "title": "Soporte"
    },
    "merchantKnowledge": {
      "title": "Conocimiento de comercios"
    }
  },
  "bootstrap": {
    "error": "No se pudo cargar la configuración de la aplicación.",
    "errorNotRegistered": "Este host no está registrado. Contacta a tu administrador.",
    "retry": "Reintentar"
  },
  "auth": {
    "redirecting": "Redirigiendo al inicio de sesión…",
    "returning": "Completando inicio de sesión…",
    "noAccessTitle": "No tienes acceso a esta consola",
    "noAccessBody": "Tu cuenta tiene la sesión iniciada, pero no se le ha concedido acceso a esta consola de administración de producto. Contacta con tu administrador si crees que se trata de un error.",
    "productAdminRequired": "Se requiere acceso de administrador de producto",
    "productAdminRequiredBody": "Has iniciado sesión, pero a tu cuenta no se le ha concedido acceso a esta consola de administración de producto.",
    "signedOutTitle": "Sesión cerrada",
    "signedOutBody": "Tu sesión de administrador de producto ha terminado.",
    "signInAgain": "Iniciar sesión de nuevo"
  },
  "errors": {
    "generic": "Algo salió mal. Inténtalo de nuevo.",
    "notFoundTitle": "No encontrado",
    "notFoundBody": "No pudimos encontrar lo que buscabas.",
    "field": {
      "rejected": "Este valor no se acepta. Revísalo e inténtalo de nuevo."
    },
    "code": {
      "SESSION_EXPIRED": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "CSRF_VALIDATION_FAILED": "No se pudo verificar la solicitud. Recarga la página e inténtalo de nuevo.",
      "INVALID_CREDENTIALS": "Esos datos de acceso no se aceptaron.",
      "CODE_INVALID": "Ese enlace de acceso ya no es válido. Inicia sesión de nuevo.",
      "INVALID_RETURN_URL": "Esa dirección de retorno no está permitida.",
      "PRODUCT_ADMIN_REQUIRED": "No tienes acceso a esta consola.",
      "PRODUCT_ADMIN_REVOKED": "Se quitó tu acceso a esta consola. Inicia sesión de nuevo.",
      "PRODUCT_CONTEXT_MISMATCH": "Esta sesión pertenece a otro producto. Inicia sesión de nuevo.",
      "ACTING_USER_NOT_PRODUCT_ADMIN": "Se quitó tu acceso a esta consola. Inicia sesión de nuevo.",
      "TENANT_ORIGIN_MISMATCH": "Esa solicitud llegó desde una dirección no permitida.",
      "RATE_LIMIT_REJECTED": "Demasiadas solicitudes. Espera un momento y vuelve a intentarlo.",
      "RATE_LIMITED": "Demasiadas solicitudes. Espera un momento y vuelve a intentarlo.",
      "INVALID_LOCALE": "Ese idioma no está disponible.",
      "NETWORK_ERROR": "No se pudo conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.",
      "VALIDATION_FAILED": "Algunos valores no se aceptaron. Revísalos e inténtalo de nuevo.",
      "SAAS_AUTH_OUTCOME_UNKNOWN": "No pudimos confirmar el cambio. Compruébalo antes de volver a intentarlo.",
      "CONCURRENT_UPDATE": "Otra persona cambió esto al mismo tiempo. Recarga e inténtalo de nuevo.",
      "TENANT_CURRENCY_NOT_PRICED": "La moneda de este tenant no está en el tarifario de su revendedor.",
      "PRODUCT_HAS_NO_DEFAULT_BRAND": "El producto no tiene una marca predeterminada que copiar. Define una en saas-admin e inténtalo de nuevo.",
      "HOSTNAME_ALREADY_REGISTERED": "Ese nombre de host ya está registrado.",
      "WHITELABEL_DOMAIN_INVALID": "Ese dominio no es válido. Revísalo e inténtalo de nuevo.",
      "RESELLER_SUSPENDED_USE_REACTIVATE": "Este revendedor está suspendido. Usa Reactivar primero.",
      "RESELLER_SUSPENDED_USE_STATUS": "Este socio está suspendido. Primero levanta la suspensión con Reactivar en su estado y vuelve a intentarlo.",
      "RESELLER_NOT_DEACTIVATED": "Este revendedor no está desactivado.",
      "RESELLER_STANDING_CONFLICT": "La situación de este revendedor cambió. Recarga e inténtalo de nuevo.",
      "RESELLER_NOT_FOUND": "No se encontró ese revendedor.",
      "RESELLER_CHARGE_NOT_FOUND": "No se encontró ese cargo.",
      "COMMISSION_PLAN_NAME_TAKEN": "Otro plan de este revendedor ya tiene ese nombre.",
      "PAYOUT_ON_HOLD": "Este pago no se puede registrar mientras está retenido.",
      "DELETION_ALREADY_REQUESTED": "Ya hay una eliminación solicitada para esta persona.",
      "DELETION_CANCELLED": "Esta solicitud de eliminación se canceló.",
      "DELETION_REQUEST_NOT_FOUND": "No se encontró esa solicitud de eliminación.",
      "PROMOTION_NOT_APPLIED": "Ahora no hay ninguna promoción aplicada a esta suscripción.",
      "PROMOTION_ALREADY_APPLIED": "Esta suscripción ya tiene una promoción. Termínala primero para aplicar otro código.",
      "PROMOTION_NOT_REDEEMABLE": "Este código no se puede usar ahora. Puede estar inactivo, fuera de sus fechas o agotado.",
      "PLAN_MAPPING_CONFLICT": "El plan de pago de esta oferta no coincide con pay-api, así que no se cambió nada. Volver a intentarlo no ayudará: pide al equipo de la plataforma que revise la oferta.",
      "PLAN_CREATE_FAILED": "pay-api no pudo crear el plan de pago, así que no se cambió nada. Inténtalo de nuevo más tarde. Si sigue fallando, pide ayuda al equipo de la plataforma.",
      "PAY_API_UNAVAILABLE": "pay-api no está disponible en este momento, así que no se cambió nada. Inténtalo de nuevo más tarde.",
      "BILLING_CONNECTION_CONFLICT": "Este tenant ya tiene otra conexión de cobros en pay-api.",
      "TAX_LOCATION_REQUIRED": "Se necesita una dirección de facturación para calcular el impuesto. Pídele al suscriptor que añada una y vuelve a intentarlo.",
      "PARKED_EVENT_STILL_REFUSED": "Se rechazó de nuevo. No se cambió nada.",
      "PARKED_EVENT_UNAVAILABLE": "pay-api ya no tiene este evento (los eventos se conservan 90 días, y el evento de un miembro borrado no se puede volver a leer). Si se gestionó en pay-api, descártalo con una nota.",
      "PARKED_EVENT_RESOLVED": "Alguien ya resolvió este evento.",
      "PARKED_EVENT_NOT_FOUND": "Este evento ya no está en espera.",
      "PARKED_EVENT_BUSY": "Este evento está ocupado ahora mismo. Inténtalo de nuevo en un momento.",
      "AFFILIATE_STATE": "El estado de este afiliado cambió. Recarga e inténtalo de nuevo.",
      "TENANT_SLUG_TAKEN": "Ese slug ya está registrado. Elige otro.",
      "TENANT_SETUP_INCOMPLETE": "No pudimos confirmar que el tenant se creó por completo. Puedes volver a intentarlo sin riesgo.",
      "TENANT_CURRENCY_LOCKED": "Bloqueada una vez que el tenant tiene suscripciones.",
      "TENANT_NOT_PRICED": "Este tenant aún no puede vender: su revendedor no tiene acuerdo.",
      "BRAND_SLUG_GENERATION_FAILED": "No se pudo generar un nombre para la nueva marca. Vuelve a intentarlo.",
      "MERCHANT_OF_RECORD_UNSET": "El comerciante registrado no está configurado.",
      "UPSTREAM_UNAVAILABLE": "El servicio de inicio de sesión no respondió. Inténtalo de nuevo.",
      "RESELLER_SUSPENDED": "Ese revendedor está suspendido y no puede recibir tenants.",
      "RESELLER_DEACTIVATED": "Ese revendedor está desactivado y no puede recibir tenants. Elige otro.",
      "RESELLER_HAS_TENANT": "Este revendedor ya tiene un tenant.",
      "RESELLER_SLUG_TAKEN": "Ese slug ya lo usa otro revendedor.",
      "RESELLER_REQUIRED": "El revendedor es obligatorio.",
      "RESELLER_CONSOLE_NOT_CONFIGURED": "tmm aún no tiene consola de revendedores, por lo que no se puede invitar a usuarios de revendedores. El operador de la plataforma la configura en saas-admin.",
      "RESELLER_CHARGE_NOT_RETRYABLE": "Este cargo no se puede reintentar ahora.",
      "RATE_CARD_IMMUTABLE": "Solo se puede cambiar un tarifario en borrador.",
      "COMMISSION_PLAN_IMMUTABLE": "Este plan ya no es un borrador. Cópialo para cambiarlo.",
      "PAYOUT_NOT_PAYABLE": "Esta liquidación se cobró a la tarjeta del revendedor; no hay nada que pagar.",
      "INVITATION_ALREADY_ACCEPTED": "Esta invitación ya fue aceptada. La lista se ha actualizado.",
      "INVITATION_ALREADY_PENDING": "Ya hay una invitación pendiente para este correo.",
      "ALREADY_ACTIVE_MEMBER": "Esta persona ya es personal activo.",
      "LAST_OWNER_PROTECTED": "Esto eliminaría al último propietario del tenant.",
      "ROLE_CHANGE_CROSSES_TABLES": "Este cambio de rol no está permitido para este miembro del personal.",
      "GHL_LOCATION_NOT_VERIFIED": "Este token no puede leer esa ubicación: revisa el id de ubicación y los permisos del token.",
      "GHL_LOCATION_ALREADY_CLAIMED": "Esa ubicación ya está conectada en otro lugar.",
      "RESELLER_PLATFORM_OWNED": "Este socio es propiedad de la plataforma y no se puede desactivar.",
      "RESELLER_HAS_TENANTS": "Este revendedor todavía tiene un tenant, así que no se puede eliminar.",
      "RESELLER_LAST_OWNER": "Esto eliminaría al último propietario del revendedor.",
      "TENANT_NOT_FOUND": "No se encontró ese tenant.",
      "ADDON_ACTIVE": "Este complemento ya está activo para este tenant.",
      "AGREEMENT_REQUIRED": "Este revendedor aún no tiene acuerdo.",
      "OFFER_NOT_ACTIVE": "Esta oferta ya no está activa. Elige otra.",
      "RATE_CARD_NOT_ACTIVE": "Primero activa o corrige el tarifario.",
      "RATE_CARD_NAME_TAKEN": "Otro tarifario de este revendedor ya tiene ese nombre.",
      "RATE_CARD_VERSION_CONFLICT": "Otra persona cambió esto. Recarga para ver sus cambios.",
      "CARD_ADOPTED": "Este revendedor usa este tarifario. Tiene que adoptar otro antes de que se pueda revocar esta concesión.",
      "RATE_CARD_NOT_FOUND": "No se encontró ese tarifario.",
      "COMMISSION_PLAN_VERSION_CONFLICT": "Otra persona cambió esto. Recarga para ver sus cambios.",
      "RATE_CARD_INVALID": "Esta versión aún no pasa las comprobaciones del tarifario.",
      "NO_RATE_CARD": "Este revendedor no ha adoptado un tarifario.",
      "PAYOUTS_MOVED_TO_LEDGER": "Los pagos se han trasladado al libro mayor de socios. Usa el libro mayor del socio.",
      "HOLD_ALREADY_OPEN": "Ya hay una retención por causa justificada abierta para este socio.",
      "HOLD_NOT_OPEN": "Esta retención ya no está abierta. El libro mayor se ha recargado.",
      "HOLD_NOT_RELEASABLE": "Esta retención no se puede liberar aquí.",
      "HOLD_OPS_ONLY": "Solo el equipo de operaciones puede liberar esta retención; está en cola.",
      "HOLD_NOT_VOIDABLE": "Solo se puede anular una retención por causa justificada.",
      "HOLD_NOT_FOUND": "No se encontró esta retención.",
      "NOTHING_TO_VOID": "El saldo no es positivo, así que no hay nada que anular.",
      "SETTLEMENT_IN_FLIGHT": "Hay un pago o un cobro en curso. Inténtalo de nuevo cuando termine.",
      "CONFIRMATION_REQUIRED": "La confirmación no coincide. Escríbela tal como aparece.",
      "PAYEE_NOT_FOUND": "Este socio aún no está configurado como beneficiario.",
      "PAYEE_RAIL_MISMATCH": "Los pagos manuales solo se registran para un socio que cobra de forma manual.",
      "PAYEE_ON_HOLD": "Los pagos del socio están retenidos por causa justificada. Libera primero la retención.",
      "STATEMENT_NOT_PAYABLE": "Este extracto no se puede pagar con ese importe.",
      "STATEMENT_NOT_FOUND": "No se encontró este extracto.",
      "TAX_YEAR_CLOSED": "Ese año fiscal ya está cerrado. El Operador registra este pago en el servicio de declaraciones.",
      "IDEMPOTENCY_CONFLICT": "Esto ya se envió con otros datos. Recarga y compruébalo.",
      "LEDGER_CUTOVER_NOT_READY": "Una comprobación de preparación no se cumple. Corrígela y vuelve a intentar este paso.",
      "TICKET_NOT_FOUND": "Este ticket no existe.",
      "TICKET_TRANSITION_INVALID": "Ese estado no puede seguir al estado actual del ticket.",
      "TICKET_DUPLICATE_INVALID": "No se puede marcar como duplicado: es el mismo ticket, ya es un duplicado o es un caso de soporte.",
      "ANNOUNCEMENT_NOT_FOUND": "Este anuncio no existe.",
      "ANNOUNCEMENT_TERM_REFUSED": "Menciona un término interno. Quítalo para publicar.",
      "ANNOUNCEMENT_NOT_DRAFT": "Este anuncio ya no es un borrador, así que no se puede cambiar. Primero retíralo.",
      "ANNOUNCEMENT_NOT_PUBLISHED": "Solo se puede expirar un anuncio publicado.",
      "MERCHANT_PATTERN_NOT_FOUND": "Este patrón de comercio ya no existe.",
      "INSTITUTION_REQUEST_NOT_FOUND": "Esta solicitud ya no existe.",
      "MERCHANT_PATTERN_NOT_PROMOTABLE": "Este patrón aún no se puede aprobar. No pasa todos los controles.",
      "MERCHANT_PATTERN_STATE": "Este patrón cambió, así que eso no se puede hacer.",
      "INSTITUTION_REQUEST_STATE": "Esta solicitud ya se atendió.",
      "INSTITUTION_EXISTS": "Ya hay un banco con este nombre en el catálogo."
    }
  },
  "help": {
    "ariaLabel": "Ayuda para {{label}}"
  },
  "tenants": {
    "pagination": {
      "previous": "Anterior",
      "next": "Siguiente",
      "pageOf": "Página {{page, number}} de {{total, number}}"
    },
    "create": {
      "title": "Crear tenant",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números, guiones — hasta 63 caracteres.",
      "slugRequired": "El slug es obligatorio.",
      "slugInvalid": "El slug debe ser una etiqueta DNS válida (minúsculas, números, guiones; hasta 63 caracteres).",
      "nameLabel": "Nombre",
      "nameRequired": "El nombre es obligatorio.",
      "nameTooLong": "El nombre debe tener 200 caracteres o menos.",
      "signupModeLabel": "Modo de registro",
      "submitButton": "Crear",
      "submitting": "Creando…",
      "cancelButton": "Cancelar",
      "errorDuplicateSlug": "Ese slug ya está registrado. Elige otro.",
      "errorGeneric": "No se pudo crear el tenant. Inténtalo de nuevo.",
      "resellerLabel": "Revendedor",
      "currencyLabel": "Moneda",
      "resellerRequired": "El revendedor es obligatorio.",
      "retrySafe": "No pudimos confirmar que el tenant se creó por completo. Puedes volver a intentarlo sin riesgo.",
      "tryAgain": "Reintentar",
      "hasTenant": "Este revendedor ya tiene un tenant.",
      "onePerReseller": "Cada revendedor tiene un tenant.",
      "billingNotProvisioned": "El tenant se creó, pero sus cobros todavía no están aprovisionados: {{reason}}. Abre Configuración → Cobros para aprovisionarlos."
    },
    "signupMode": {
      "PUBLIC": "Público",
      "INVITE_ONLY": "Solo por invitación",
      "ADMIN_CREATED_ONLY": "Solo creado por admin",
      "DISABLED": "Desactivado"
    },
    "status": {
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "SUSPENDED": "Suspendido"
    },
    "reseller": {
      "deactivated": "Ese revendedor está desactivado y no puede recibir tenants. Elige otro.",
      "suspended": "Ese revendedor está suspendido y no puede recibir tenants."
    },
    "deleteNote": "Para suspender o eliminar un tenant, consulta al operador de la plataforma (saas-admin).",
    "sellable": {
      "chip": "No puede vender",
      "noReseller": {
        "label": "Sin revendedor",
        "body": "Este tenant no puede vender hasta que pertenezca a un revendedor."
      },
      "noAgreement": {
        "label": "Sin acuerdo",
        "body": "Su revendedor no tiene un acuerdo vigente."
      },
      "currencyNotPriced": {
        "label": "Moneda sin precio",
        "body": "La moneda del tenant ({{currency}}) no es la moneda del tarifario de su revendedor."
      },
      "unknown": {
        "label": "No puede vender ({{code}})",
        "body": "Revisa el revendedor, el acuerdo, la moneda y las ofertas de este tenant."
      },
      "editTenant": "Editar tenant…",
      "noRateCard": {
        "label": "Sin tarifario",
        "body": "Este tenant no puede vender hasta que su revendedor active un tarifario."
      },
      "openCustomerPrices": "Abrir tarifario"
    },
    "notPriced": {
      "currencyMessage": "La moneda de este tenant ({{currency}}) no tiene precio en el tarifario de su revendedor.",
      "message": "Este tenant aún no puede vender: su revendedor no tiene acuerdo.",
      "openAgreement": "Abrir el acuerdo de {{resellerName}}"
    },
    "edit": {
      "aiDefault": "IA activada de forma predeterminada",
      "button": "Editar…",
      "currencyLabel": "Moneda",
      "currencyLocked": "Bloqueada una vez que el tenant tiene suscripciones",
      "error": "No se pudo actualizar el tenant.",
      "nameLabel": "Nombre",
      "nameRequired": "El nombre es obligatorio (200 caracteres como máximo).",
      "save": "Guardar",
      "signupModeLabel": "Modo de registro",
      "statusLabel": "Estado",
      "suspendConfirm": "Sus usuarios no pueden iniciar sesión hasta que se reactive.",
      "title": "Editar tenant"
    },
    "upstreamUnavailable": "El servicio de inicio de sesión no respondió por completo. No se cambió nada; inténtalo de nuevo.",
    "statusFilter": {},
    "resellerFilter": {}
  },
  "tenant": {
    "tab": {
      "affiliates": "Afiliados"
    },
    "section": {}
  },
  "tenantDetail": {
    "notFound": "Tenant no encontrado.",
    "identity": {
      "loadError": "No se pudo cargar la identidad del tenant.",
      "created": "Creado el {{date}}",
      "status": {}
    },
    "members": {
      "help": "Quién administra este tenant.",
      "removeConfirmBody": "Esto elimina a {{email}} del personal de este tenant. La cuenta de esa persona no se elimina.",
      "title": "Administradores del tenant",
      "tableAriaLabel": "Personal del tenant",
      "col": {
        "email": "Correo",
        "name": "Nombre",
        "role": "Rol",
        "status": "Estado",
        "actions": "Acciones"
      },
      "role": {
        "OWNER": "Propietario",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Personal",
        "USER": "Usuario",
        "GUEST": "Invitado"
      },
      "status": {
        "ACTIVE": "Activo",
        "INVITED": "Invitado",
        "DISABLED": "Deshabilitado"
      },
      "loadError": "No se pudo cargar el personal.",
      "empty": "Aún no hay administradores.",
      "changeRoleLabel": "Rol para {{email}}",
      "changeRoleError": "No se pudo cambiar el rol. Inténtalo de nuevo.",
      "disableLabel": "Habilitado",
      "toggleStatusError": "No se pudo actualizar el estado del personal. Inténtalo de nuevo.",
      "removeButton": "Quitar",
      "removeConfirmTitle": "¿Quitar personal?",
      "removeError": "No se pudo quitar al personal. Inténtalo de nuevo.",
      "lastOwnerProtected": "Esto eliminaría al último propietario del tenant.",
      "roleChangeCrossesTables": "Este cambio de rol no está permitido para este miembro del personal.",
      "addTitle": "Agregar administrador",
      "addEmailLabel": "Correo",
      "addEmailRequired": "El correo es obligatorio.",
      "addRoleLabel": "Rol",
      "addButton": "Agregar",
      "addSuccessMember": "Personal agregado.",
      "addSuccessInvitation": "Invitación enviada.",
      "addErrorAlreadyActive": "Esta persona ya es personal activo.",
      "addErrorAlreadyPending": "Ya hay una invitación pendiente para este correo.",
      "addError": "No se pudo agregar al personal. Inténtalo de nuevo."
    },
    "customers": {
      "title": "Clientes",
      "help": "Usuarios finales de este tenant. Los detalles de suscripción llegarán del backend del producto más adelante.",
      "tableAriaLabel": "Clientes del tenant",
      "searchLabel": "Buscar usuarios",
      "col": {
        "email": "Correo",
        "name": "Nombre",
        "status": "Estado"
      },
      "loadError": "No se pudieron cargar los clientes.",
      "empty": "Aún no hay clientes.",
      "emptySearch": "Ningún cliente coincide con la búsqueda.",
      "pagination": {
        "pageOf": "Página {{page, number}} de {{total, number}}"
      }
    },
    "invitations": {
      "title": "Invitaciones",
      "tableAriaLabel": "Invitaciones del tenant",
      "col": {
        "email": "Correo",
        "role": "Rol",
        "status": "Estado",
        "created": "Creada",
        "expires": "Expira",
        "actions": "Acciones"
      },
      "statusAll": "Mostrar todas",
      "status": {
        "PENDING": "Pendiente",
        "ACCEPTED": "Aceptada",
        "REVOKED": "Eliminada",
        "EXPIRED": "Expirada"
      },
      "loadError": "No se pudieron cargar las invitaciones.",
      "empty": "No hay invitaciones pendientes.",
      "emptyAll": "No hay invitaciones.",
      "resendButton": "Reenviar",
      "resendError": "No se pudo reenviar la invitación. Inténtalo de nuevo.",
      "revokeButton": "Revocar",
      "revokeConfirmTitle": "¿Revocar invitación?",
      "revokeConfirmBody": "Esto revoca la invitación pendiente a {{email}}. Ya no podrá aceptarla.",
      "revokeError": "No se pudo revocar la invitación. Inténtalo de nuevo.",
      "alreadyAccepted": "Esta invitación ya fue aceptada. La lista se ha actualizado.",
      "notFound": "No se encontró esta invitación. La lista se ha actualizado."
    },
    "overview": {
      "period": "Período",
      "kpi": {
        "activeSubscribers": "Suscriptores activos",
        "trialing": "En prueba",
        "comped": "Cortesía",
        "guestSeats": "Asientos de invitado",
        "chargedSeats_one": "{{shown}} cobrado",
        "chargedSeats_other": "{{shown}} cobrados",
        "connectedAccounts": "Cuentas conectadas",
        "retail": "Minorista",
        "tenantShare": "Parte del tenant",
        "platformShare": "Parte de la plataforma",
        "pendingPayout": "Pago pendiente",
        "nextClose": "próximo cierre {{date}}",
        "noData": "—"
      },
      "currency": "Moneda",
      "aiDefault": "IA activada por defecto",
      "yes": "Sí",
      "no": "No",
      "emailFromName": "Nombre del remitente",
      "emailFromAddress": "Dirección del remitente",
      "emailSupportEmail": "Correo de soporte"
    },
    "offers": {
      "tableAria": "Ofertas del tenant",
      "aiMarkupHelp": "Lo que el cliente paga sobre el costo del proveedor de IA: nuestro margen combinado con el del revendedor.",
      "col": {
        "id": "Oferta",
        "status": "Estado",
        "retailBase": "Base minorista",
        "seatBands": "Bandas de asientos",
        "aiMarkup": "Margen de IA (total del cliente)",
        "trial": "Prueba (nuevo / invitado)",
        "subscribers": "Suscriptores",
        "created": "Creado",
        "closed": "Cerrado",
        "rateCard": "Tarifario"
      },
      "current": "Actual",
      "empty": "Aún no hay ofertas.",
      "loadError": "No se pudieron cargar las ofertas.",
      "rateCardById": "Tarifario {{id}}"
    },
    "promotions": {
      "tableAria": "Promociones del tenant",
      "col": {
        "code": "Código",
        "name": "Nombre",
        "kind": "Tipo",
        "value": "Valor",
        "valid": "Vigencia",
        "redemptions": "Canjes",
        "status": "Estado",
        "newOnly": "Solo nuevos suscriptores"
      },
      "kind": {
        "OFFER": "Oferta",
        "TRIAL_DAYS": "Días de prueba",
        "PERCENT_OFF_VARIABLE": "Porcentaje de descuento",
        "AMOUNT_OFF_VARIABLE": "Importe de descuento"
      },
      "status": {
        "ACTIVE": "Activa",
        "PAUSED": "Pausada",
        "ENDED": "Finalizada"
      },
      "empty": "No hay promociones.",
      "loadError": "No se pudieron cargar las promociones."
    },
    "sections": {},
    "sectionTabs": {}
  },
  "resellers": {
    "loadError": "No se pudieron cargar los revendedores.",
    "cancel": "Cancelar",
    "save": "Guardar",
    "statusFilter": {
      "label": "Estado",
      "all": "Todos",
      "active": "Activo",
      "suspended": "Suspendido"
    },
    "col": {
      "status": "Estado",
      "created": "Creado",
      "actions": "Acciones",
      "standing": "Situación"
    },
    "role": {
      "OWNER": "Propietario",
      "ADMIN": "Administrador",
      "STAFF": "Personal"
    },
    "create": {
      "title": "Crear revendedor",
      "slugLabel": "Slug",
      "slugHelper": "Letras minúsculas, números y guiones — hasta 63 caracteres.",
      "slugRequired": "El slug es obligatorio.",
      "slugInvalid": "El slug debe ser una etiqueta DNS válida (letras minúsculas, números y guiones; hasta 63 caracteres).",
      "slugTaken": "Ese slug ya lo usa otro revendedor.",
      "nameLabel": "Nombre",
      "nameRequired": "El nombre es obligatorio.",
      "nameTooLong": "El nombre debe tener 200 caracteres o menos.",
      "submitButton": "Crear",
      "submitting": "Creando…",
      "errorGeneric": "No se pudo crear el revendedor. Inténtalo de nuevo."
    },
    "detail": {
      "loadError": "No se pudo cargar el revendedor."
    },
    "tab": {
      "agreement": "Acuerdo"
    },
    "standing": {
      "GOOD": "Buena",
      "PROBATION": "Prueba",
      "DEACTIVATION_DUE": "Desactivación pendiente",
      "DEACTIVATED": "Desactivado",
      "unknown": "Desconocido ({{state}})",
      "probationWindow": "Ventana de prueba",
      "notEvaluated": "Aún no evaluado. Cada mes desde el lanzamiento oficial se evalúa el día 2 del mes siguiente.",
      "loadError": "No se pudo cargar la situación.",
      "tableAria": "Situación por mes",
      "reactivated": "Reactivado el {{date}}. El compromiso mínimo se reinicia a partir de entonces.",
      "saasAuthStatus": "Estado en saas-auth",
      "saasAuthActive": "Activo",
      "saasAuthSuspended": "Suspendido",
      "saasAuthCaption": "Según lo último que vio tmm-api.",
      "col": {
        "month": "Mes",
        "minimum": "Mínimo",
        "earned": "Ganado",
        "shortfall": "Déficit",
        "shortfallCharge": "Cargo por déficit"
      },
      "officialLaunch": "Lanzamiento oficial",
      "launchNotSet": "Sin definir: no se evalúa ningún mes hasta que el acuerdo defina uno.",
      "launchNoneSet": "No hay lanzamiento oficial definido.",
      "openAgreement": "Abrir la pestaña Acuerdo",
      "probationDeadline": "Fecha límite de la prueba",
      "judgedOn": "Se evalúa el {{date}}",
      "nextNotice": "Próximo aviso",
      "noNotice": "Ninguno programado",
      "notEvaluatedNoLaunch": "Sin evaluar: aún no hay lanzamiento oficial.",
      "viewCharge": "Ver cargo",
      "viewChargeAria": "Ver cargo de {{month}}",
      "endProbation": {
        "button": "Terminar la prueba…",
        "title": "¿Terminar la prueba de {{name}}?",
        "body": "Termina la prueba ahora. Se envía un correo al revendedor indicando que se ha recuperado.",
        "confirm": "Terminar la prueba",
        "done": "Prueba terminada. El revendedor está en buena situación.",
        "conflict": "Este revendedor ya no está en prueba, así que no había nada que terminar. Se recargó la pantalla.",
        "error": "No se pudo terminar la prueba."
      }
    },
    "deactivate": {
      "title": "Desactivar socio",
      "confirm": "¿Desactivar {{from}}?",
      "submit": "Desactivar",
      "error": "No se pudo desactivar el socio.",
      "consequence": "Desactivar suspende a los administradores de este socio y la plataforma pasa a gestionarlo. Su tenant sigue vendiendo. La plataforma retiene las liquidaciones (no se paga nada) hasta que lo reactives."
    },
    "reactivate": {
      "button": "Reactivar…",
      "title": "¿Reactivar {{name}}?",
      "body": "Reactivar restablece el acceso de los administradores de este socio y reanuda los pagos desde la próxima liquidación. Las liquidaciones ya retenidas siguen retenidas.",
      "reason": "Motivo",
      "counter_one": "{{count, number}}/{{max, number}}",
      "counter_other": "{{count, number}}/{{max, number}}",
      "confirm": "Reactivar",
      "done": "{{name}} está activo de nuevo.",
      "error": "No se pudo reactivar el revendedor.",
      "conflict": "Se rechazó la reactivación porque el estado de este revendedor cambió. Se recargó la pantalla.",
      "notDeactivated": "Este socio no está desactivado. Usa Reactivar en el control de estado para levantar una suspensión ordinaria."
    },
    "overview": {
      "updated": "Actualizado",
      "brand": "Marca",
      "visibility": "Visibilidad",
      "ownBrand": "Tiene su propia marca",
      "productBrand": "Sin marca propia: sus tenants usan la marca del producto.",
      "renameHelper": "La marca del revendedor adopta el nuevo nombre salvo que se haya personalizado.",
      "suspend": "Suspender",
      "suspendTitle": "¿Suspender {{name}}?",
      "suspendBody": "Sus usuarios no pueden iniciar sesión. Sus tenants siguen funcionando.",
      "reactivate": "Reactivar",
      "reactivateTitle": "¿Reactivar {{name}}?",
      "reactivateBody": "Sus usuarios pueden volver a iniciar sesión.",
      "statusError": "No se pudo cambiar el estado del revendedor.",
      "statusStandingConflict": "Este revendedor está desactivado, así que su estado no se puede cambiar aquí. Usa Reactivar… para recuperarlo. Se recargó la pantalla.",
      "delete": "Eliminar…",
      "deleteTitle": "¿Eliminar {{name}}?",
      "deleteBody": "Esto elimina el revendedor y su marca. No se puede deshacer.",
      "deleteConfirm": "Eliminar",
      "deleteError": "No se pudo eliminar el revendedor.",
      "deactivate": "Desactivar…",
      "deactivationDue": "Este socio no alcanzó su mínimo durante el período de prueba. Consérvalo y revisa el próximo mes, o desactívalo para que la plataforma lo gestione sin trasladarlo.",
      "deactivated": "Este socio está desactivado. Sus administradores no pueden iniciar sesión; su tenant sigue vendiendo.",
      "takeoverReactivate": "Este socio puede reactivarse durante la toma de control.",
      "deactivatedButActive": "Activo en saas-auth, así que es posible que sus usuarios puedan iniciar sesión. Reactívalo aquí, o pide al operador de la plataforma que lo vuelva a suspender en saas-admin.",
      "createBrand": "Crear marca",
      "brandCreated": "Marca creada.",
      "brandCreateError": "No se pudo crear la marca.",
      "brandEditedIn": "La marca se edita en saas-admin.",
      "keep": {
        "button": "Conservar este revendedor…",
        "title": "¿Conservar {{name}}?",
        "body": "Quita la marca de desactivación. Sus cargos por déficit siguen abiertos.",
        "reason": "Motivo",
        "counter_one": "{{count, number}}/{{max, number}}",
        "counter_other": "{{count, number}}/{{max, number}}",
        "confirm": "Conservar este revendedor",
        "done": "Conservado. Se quitó la marca de desactivación; sus cargos por déficit siguen abiertos.",
        "error": "No se pudo conservar el revendedor.",
        "conflict": "Este revendedor ya no está pendiente de desactivación, así que no había nada que quitar. Se recargó la pantalla.",
        "suspended": "Este revendedor está suspendido en saas-auth, así que borrar no basta. Usa Reactivar… en su lugar."
      },
      "brandNoProductDefault": "El producto no tiene una marca predeterminada que copiar. Define una en saas-admin y vuelve a intentarlo.",
      "brandSlugFailed": "No se pudo generar un nombre para la nueva marca. Vuelve a intentarlo.",
      "probation": "Este revendedor está en prueba por no alcanzar su mínimo. Termina la prueba si se ha recuperado.",
      "details": "Detalles",
      "card": {
        "standing": "Situación",
        "latestSettlement": "Última liquidación",
        "none": "Ninguno",
        "loadError": "No se pudo cargar esto.",
        "meaning": {
          "GOOD": "Cumple su mínimo.",
          "PROBATION": "No alcanzó su mínimo y está en prueba.",
          "DEACTIVATION_DUE": "No alcanzó su mínimo durante toda la prueba.",
          "DEACTIVATED": "Sus administradores pierden el acceso; su tenant sigue vendiendo."
        },
        "affiliateAssigned": "{{plans, number}} planes · {{affiliates, number}} afiliados asignados"
      }
    },
    "users": {
      "searchLabel": "Buscar usuarios",
      "invite": "Invitar administrador…",
      "inviteTitle": "Invitar administrador",
      "inviteSubmit": "Enviar invitación",
      "emailLabel": "Correo electrónico",
      "roleLabel": "Rol",
      "emailRequired": "El correo electrónico es obligatorio.",
      "invited": "Invitación enviada.",
      "inviteError": "No se pudo enviar la invitación.",
      "noConsole": "tmm aún no tiene consola de revendedores, por lo que no se puede invitar a usuarios de revendedores. El operador de la plataforma la configura en saas-admin.",
      "loadError": "No se pudieron cargar los usuarios.",
      "tableAriaLabel": "Usuarios del revendedor",
      "empty": "Aún no hay usuarios.",
      "col": {
        "email": "Correo electrónico",
        "name": "Nombre",
        "role": "Rol",
        "status": "Estado",
        "mfa": "MFA",
        "password": "Contraseña"
      },
      "roleFor": "Rol de {{email}}",
      "roleError": "No se pudo cambiar el rol.",
      "mfaOn": "MFA",
      "passwordSet": "Contraseña",
      "suspend": "Suspender",
      "reactivate": "Reactivar",
      "statusError": "No se pudo cambiar el estado.",
      "remove": "Quitar",
      "removeTitle": "¿Quitar usuario?",
      "removeBody": "Esto quita a {{email}} de este revendedor, con su contraseña y sus sesiones.",
      "removeError": "No se pudo quitar al usuario."
    },
    "invitations": {
      "tableAriaLabel": "Invitaciones del revendedor"
    },
    "ghl": {
      "title": "Conexión GHL",
      "notConnected": "No conectado",
      "connect": "Conectar…",
      "connectTitle": "Conectar GHL",
      "edit": "Editar…",
      "editTitle": "Editar conexión GHL",
      "disconnect": "Desconectar…",
      "disconnectTitle": "¿Desconectar GHL?",
      "disconnectBody": "Esto elimina la conexión GHL del revendedor y su token guardado.",
      "disconnectConfirm": "Desconectar",
      "disconnected": "Desconectado.",
      "disconnectError": "No se pudo desconectar.",
      "loadError": "No se pudo cargar la conexión GHL.",
      "locationId": "Id de ubicación",
      "locationClaimed": "Esa ubicación ya está conectada en otro lugar.",
      "locationRule": "1–64 letras, dígitos, '_' o '-'. Déjalo en blanco para no usar ubicación.",
      "locationNotVerified": "Este token no puede leer esa ubicación: revisa el id de ubicación y los permisos del token.",
      "token": "Token de integración privada",
      "tokenNotSet": "No configurado",
      "tokenHelper": "Déjalo en blanco para conservar el token actual",
      "active": "Activa",
      "yes": "Sí",
      "no": "No",
      "saved": "Conexión GHL guardada.",
      "saveError": "No se pudo guardar la conexión.",
      "diagnose": {
        "button": "Diagnosticar",
        "running": "Ejecutando el diagnóstico",
        "wait": "Comprobando GHL — puede tardar unos segundos.",
        "error": "No se pudo ejecutar el diagnóstico.",
        "title": "Diagnóstico",
        "unknown": "GoHighLevel devolvió un resultado que esta consola no reconoce.",
        "copyDetails": "Copiar detalles para soporte",
        "interpretation": {
          "HEALTHY": "Correcto",
          "LIKELY_MISSING_SCOPE": "Falta un permiso",
          "LIKELY_CREDENTIAL_CORRUPT": "Token dañado",
          "LIKELY_CREDENTIAL_INVALID": "Token rechazado",
          "UPSTREAM_UNAVAILABLE": "GHL no disponible",
          "INDETERMINATE": "Sin patrón claro"
        },
        "hint": {
          "HEALTHY": "Las dos comprobaciones pasaron.",
          "LIKELY_MISSING_SCOPE": "Al token le falta un permiso que GHL necesita.",
          "LIKELY_CREDENTIAL_CORRUPT": "El token guardado parece dañado — vuelve a configurarlo.",
          "LIKELY_CREDENTIAL_INVALID": "GHL rechazó el token — reemplázalo.",
          "UPSTREAM_UNAVAILABLE": "GHL no respondió — inténtalo más tarde.",
          "INDETERMINATE": "Las comprobaciones no coinciden con un patrón conocido — mira los resultados abajo."
        },
        "contacts": "Contactos",
        "customFields": "Campos personalizados",
        "check": "Comprobación",
        "result": "Resultado",
        "ok": "Correcto",
        "failed": "Fallido"
      },
      "saveWait": "Comprobando el token con GHL: puede tardar hasta 30 segundos.",
      "connectionName": "la conexión de GHL"
    },
    "agreement": {
      "dialog": {
        "takesEffectNow": "Entra en vigor ahora.",
        "confirm": "Iniciar una nueva versión finaliza el acuerdo actual y vuelve a fijar el precio de cada tenant de {{reseller}}. Los suscriptores conservan la oferta que compraron.",
        "confirmSubmit": "Iniciar versión",
        "connectTenant": "Tenant de Connect",
        "createTitle": "Crear acuerdo",
        "minPayout": "Pago mínimo",
        "monthlyMinimum": "Mínimo mensual",
        "newTitle": "Nueva versión del acuerdo",
        "notes": "Notas",
        "probation": "Meses de prueba",
        "officialLaunch": "Lanzamiento oficial",
        "launchSetHelp": "No se puede quitar una vez definido. Puedes moverlo a otro mes.",
        "launchUnsetHelp": "El día 1 del mes elegido. No se evalúa ningún mes hasta que se defina.",
        "launchKeep": "{{month}} (actual)",
        "launchNotSet": "Sin definir",
        "launchConfirm": "El lanzamiento oficial pasa a ser {{month}}. No se puede quitar una vez definido.",
        "currency": "Moneda"
      },
      "by": "Por",
      "cadence": {
        "MONTHLY": "Mensual",
        "WEEKLY": "Semanal"
      },
      "cadenceLabel": "Cadencia de pago",
      "col": {
        "cadence": "Cadencia",
        "effectiveFrom": "Vigente desde",
        "ended": "Finalizado",
        "method": "Método",
        "monthlyMin": "Mínimo mensual",
        "officialLaunch": "Lanzamiento oficial",
        "currency": "Moneda"
      },
      "connectTenant": "Tenant de Connect",
      "create": "Crear acuerdo…",
      "current": "Acuerdo actual",
      "effectiveFrom": "Vigente desde",
      "error": "No se pudo iniciar el acuerdo.",
      "history": "Historial",
      "historyAria": "Historial del acuerdo",
      "historyEmpty": "No hay versiones anteriores.",
      "loadError": "No se pudo cargar el acuerdo.",
      "methodLabel": "Método de pago",
      "minPayout": "Pago mínimo",
      "monthlyMinimum": "Mínimo mensual",
      "newVersion": "Nueva versión…",
      "none": "Sin acuerdo. Los tenants de este revendedor no pueden vender hasta que exista uno.",
      "notes": "Notas",
      "payoutAccount": "Cuenta de pago",
      "probation": "Meses de prueba",
      "probationHint": "Un mes por debajo del mínimo abre un período de prueba; tmm marca al revendedor para su desactivación si no se recupera.",
      "probationInvalid": "Debe ser cero o mayor.",
      "taxDocs": {
        "COLLECTED": "Recopilado",
        "NOT_REQUIRED": "No requerido",
        "PENDING": "Pendiente"
      },
      "taxDocsLabel": "Documentos fiscales",
      "taxIdLabel": "ID fiscal",
      "taxIdCurrent": "ID fiscal del socio en pay-api",
      "taxId": {
        "MISMATCH": "No coincide",
        "NOT_REQUIRED": "No requerido",
        "PENDING": "Pendiente",
        "VERIFIED": "Verificado"
      },
      "officialLaunch": "Lanzamiento oficial",
      "launchNotSet": "Sin definir",
      "launchNotSetLong": "Sin definir: no se evalúa ningún mes hasta que se defina uno.",
      "page": {
        "startVersion": "Iniciar nueva versión",
        "create": "Crear acuerdo"
      },
      "section": {
        "pricing": "Precios y lanzamiento",
        "payouts": "Pagos",
        "minimum": "Mínimo mensual"
      },
      "preview": {
        "minPayout": "Se paga cuando alcanza al menos {{amount}}",
        "monthlyMinimum": "Al menos {{amount}} al mes"
      },
      "started": "Versión del acuerdo iniciada para {{reseller}}.",
      "currencyHelp": "Por defecto, la moneda del tarifario adoptado.",
      "versionFrom": "Acuerdo desde {{date}}",
      "currency": "Moneda",
      "currencyNotChosen": "Sin elegir",
      "currencyNoAdoption": "Este revendedor no ha adoptado un tarifario, así que elige la moneda."
    },
    "settlements": {
      "filter": {
        "currency": "Moneda",
        "allCurrencies": "Todas",
        "from": "Desde",
        "to": "Hasta",
        "status": "Estado",
        "allStatuses": "Todos"
      },
      "loadError": "No se pudieron cargar las liquidaciones.",
      "tableAria": "Liquidaciones",
      "col": {
        "month": "Mes",
        "currency": "Moneda",
        "margin": "Margen",
        "affiliates": "Afiliados",
        "net": "Neto",
        "outcome": "Resultado",
        "actions": "Acciones"
      },
      "empty": "No hay liquidaciones.",
      "emptyBody": "Cada mes se cierra el día 2 del mes siguiente, con una liquidación por moneda.",
      "expand": "Expandir {{month}}",
      "collapse": "Contraer {{month}}",
      "recordAria": "Registrar pago… de {{month}} {{currency}}",
      "outcome": {
        "PAID": "Pagado el {{date}}",
        "PENDING": "Por pagar",
        "CARRIED": "Trasladado (bajo el mínimo)",
        "CHARGED": "Cobrado a la tarjeta",
        "RETAINED": "Retenido"
      },
      "viewChargeAria": "Ver cargo de {{month}} {{currency}}",
      "byLineAria": "Liquidación por línea",
      "byLine": {
        "line": "Línea",
        "retail": "Minorista",
        "wholesale": "Mayorista",
        "margin": "Margen",
        "affiliates": "Afiliados",
        "aiAtOurPrice": "IA a nuestro precio"
      },
      "events": {
        "aria": "Bonos de captación e hitos de afiliado",
        "line": "Línea",
        "amount": "Importe",
        "bounties": "Bonos de captación de afiliado",
        "milestones": "Hitos de afiliado",
        "recovered": "Reversiones recuperadas"
      },
      "retainedTooltip": "La plataforma lo conserva mientras gestiona este socio; no se paga nada.",
      "retainedPart": "Retenido {{amount}}",
      "normalPart": "Pagadero {{amount}}"
    },
    "notices": {
      "sent": "Avisos enviados",
      "filter": {
        "kind": "Tipo",
        "allKinds": "Todos los tipos"
      },
      "tableAria": "Avisos",
      "col": {
        "when": "Enviado / creado",
        "kind": "Tipo",
        "period": "Período",
        "status": "Estado",
        "recipients": "Destinatarios"
      },
      "loadError": "No se pudieron cargar los avisos.",
      "empty": "Aún no hay avisos.",
      "emptyFiltered": "Ningún aviso coincide con este filtro.",
      "expand": "Expandir {{kind}}, {{period}}",
      "collapse": "Contraer {{kind}}, {{period}}",
      "created": "Creado, no enviado",
      "recipients": "{{n, number}} destinatarios",
      "factsAria": "Datos: {{kind}}, {{period}}",
      "chargesAria": "Cargos de este aviso",
      "kind": {
        "LAUNCH_REMINDER": "Recordatorio de lanzamiento",
        "PROBATION_STARTED": "Período de prueba iniciado",
        "PROBATION_MONTHLY": "Actualización del período de prueba",
        "CHARGE_FAILED": "Cargo fallido",
        "CHARGE_ACTION_REQUIRED": "El cargo requiere acción",
        "DEACTIVATED": "Desactivado",
        "RECOVERED": "Recuperado"
      },
      "status": {
        "PENDING": "Pendiente",
        "SENDING": "Enviando",
        "SENT": "Enviado",
        "SKIPPED": "Omitido",
        "FAILED": "Fallido"
      },
      "statusHint": {
        "PENDING": "Aún no enviado. El motor de avisos lo envía en menos de una hora.",
        "SKIPPED": "No enviado: correo no configurado, sin destinatario o ya no es necesario"
      },
      "fact": {
        "month": "Mes",
        "currency": "Moneda",
        "shortfall": "Faltante",
        "probationMonths": "Meses de prueba",
        "target": "Mínimo del período de prueba",
        "earned": "Ganado hasta ahora",
        "stillNeeded": "Aún falta",
        "deactivationOn": "Fecha de desactivación",
        "launchOn": "Lanzamiento oficial",
        "toReseller": "Tenants movidos a",
        "tenantsMoved": "Tenants movidos"
      },
      "charge": {
        "kind": "Cargo",
        "amount": "Importe",
        "status": "Estado",
        "holdOn": "Retiene pagos desde"
      }
    },
    "section": {},
    "sectionCaption": {},
    "actions": {}
  },
  "dashboard": {
    "tabs": {
      "aria": "Secciones del panel",
      "trends": "Tendencias",
      "tenants": "Tenants",
      "resellers": "Revendedores"
    },
    "period": {
      "label": "Período",
      "THIS_MONTH": "Este mes",
      "LAST_30_DAYS": "Últimos 30 días",
      "LAST_MONTH": "Mes anterior"
    },
    "loadError": "No se pudo cargar el panel de la flota.",
    "kpi": {
      "activeSubscribers": "Suscriptores activos",
      "acrossTenants_one": "en {{count, number}} tenant",
      "acrossTenants_other": "en {{count, number}} tenants",
      "trialing": "En prueba",
      "newAndChurned": "{{new}} nuevos · {{churned}} bajas",
      "retailCollected": "Cobrado al público",
      "beforeShares": "antes de las participaciones",
      "platformShare": "Participación de la plataforma",
      "reachedUs": "lo que nos llegó",
      "pendingPayouts": "Pagos pendientes",
      "paidInPeriod": "{{paid}} pagados en el período",
      "addonsActive": "Complementos activos",
      "connectedAccounts": "Cuentas conectadas",
      "guestSeats": "Asientos de invitados",
      "tenantShare": "Participación del tenant",
      "uplift": "Incremento",
      "wholesale": "Mayorista"
    },
    "chart": {
      "retailTitle": "Ventas por tenant",
      "subscribersTitle": "Suscriptores activos por día",
      "subscribersAria": "Suscriptores activos por día",
      "empty": "Sin actividad en este período.",
      "retailAriaCurrency": "Ventas por tenant en {{currency}}, de {{from}} a {{to}}",
      "retailTitleCurrency": "Ventas por tenant · {{currency}}"
    },
    "fleet": {
      "subtitle": "Ventas es lo que pagaron los suscriptores. Plataforma es lo que retenemos tras la participación del tenant.",
      "tableAria": "Flota por tenant",
      "col": {
        "tenant": "Tenant",
        "subscribers": "Suscriptores",
        "new": "Nuevos",
        "churned": "Bajas",
        "retail": "Ventas",
        "wholesale": "Mayorista",
        "uplift": "Sobreprecio",
        "tenantShare": "Participación del tenant",
        "platform": "Plataforma",
        "nextClose": "Próximo cierre"
      },
      "totalsInCurrency": "Totales en {{currency}}",
      "empty": "Aún no hay tenants."
    },
    "standing": {
      "deactivationDue_one": "{{count, number}} revendedor no alcanzó el mínimo durante la prueba y está pendiente de desactivación.",
      "deactivationDue_other": "{{count, number}} revendedores no alcanzaron el mínimo durante la prueba y están pendientes de desactivación."
    },
    "byReseller": {
      "col": {
        "platform": "Participación de la plataforma",
        "reseller": "Revendedor",
        "retail": "Minorista",
        "subscribers": "Suscriptores activos",
        "tenants": "Tenants"
      },
      "noReseller": "Sin revendedor",
      "tableAria": "Flota por revendedor",
      "title": "Por revendedor"
    },
    "affiliateBonuses": {
      "title": "Bonos de afiliado",
      "tableAria": "Bonos de afiliado por revendedor",
      "col": {
        "reseller": "Revendedor",
        "currency": "Moneda",
        "bounties": "Bonos de captación",
        "milestones": "Hitos"
      }
    },
    "resellerFilter": {
      "all": "Todos"
    },
    "unpaidCharges": {
      "title": "Cargos de revendedores sin pagar:",
      "item_one": "{{shown}} · {{amount}}",
      "item_other": "{{shown}} · {{amount}}"
    },
    "retainedMargin": {
      "title": "Margen retenido",
      "absorbed": "Absorbido por la plataforma."
    }
  },
  "rateCards": {
    "status": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "CLOSED": "Cerrado"
    },
    "ai": "IA",
    "actions": {
      "activate": "Activar",
      "close": "Cerrar",
      "copy": "Copiar"
    },
    "form": {
      "name": "Nombre",
      "currency": "Moneda",
      "trialNew": "Días de prueba — nuevo suscriptor",
      "trialGuest": "Días de prueba — conversión de invitado",
      "nonNegative": "Debe ser cero o mayor.",
      "section": {
        "trials": "Pruebas"
      }
    },
    "help": {
      "trialNew": {
        "short": "Días gratis antes del primer cargo para quien se suscribe directamente. 0 = paga desde el primer día."
      },
      "trialGuest": {
        "short": "Días gratis para un invitado que se convierte en suscriptor."
      },
      "aiFirstPurchase": {
        "short": "Lo que una persona paga la primera vez que activa la IA. Habilita la IA."
      },
      "aiRechargeTrigger": {
        "short": "Cuando el saldo de IA baja de este valor, se cobra el importe de la recarga a la tarjeta del suscriptor."
      },
      "aiRechargeAmount": {
        "short": "Lo que cobra una recarga automática. También es la recarga manual más pequeña."
      }
    }
  },
  "subscription": {
    "status": {
      "ACTIVE": "Activa",
      "TRIALING": "En prueba",
      "CANCELLED": "Cancelada",
      "ENDING": "Finalizando",
      "ENDED": "Finalizada",
      "PAST_DUE": "Vencida",
      "COMPED": "Cortesía"
    }
  },
  "subscriptions": {
    "tabs": {
      "aria": "Secciones de suscripciones",
      "subscriptions": "Suscripciones",
      "pending": "Pendiente",
      "count": "{{label}} ({{count, number}})"
    },
    "tableAria": "Suscripciones del tenant",
    "loadError": "No se pudieron cargar las suscripciones.",
    "empty": "No hay suscripciones.",
    "statusFilter": "Estado",
    "statusAll": "Todas",
    "emailFilter": "Correo",
    "subscribe": "Suscribir",
    "view": "Ver",
    "offerCurrent": "actual",
    "col": {
      "email": "Correo",
      "name": "Nombre",
      "status": "Estado",
      "origin": "Origen",
      "offer": "Oferta",
      "period": "Periodo",
      "nextBilling": "Próximo cobro",
      "card": "Tarjeta",
      "actions": "Acciones"
    },
    "origin": {
      "SELF": "Propia",
      "ADMIN": "Admin",
      "COMP": "Cortesía"
    },
    "pending": {
      "title": "Suscripciones admin pendientes",
      "empty": "No hay suscripciones pendientes.",
      "email": "Correo",
      "status": "Estado",
      "offer": "Oferta",
      "trialDays": "Días de prueba",
      "comp": "Cortesía hasta {{compedUntil}}",
      "compLabel": "Cortesía",
      "createdBy": "Creada por",
      "expires": "Caduca"
    },
    "pendingStatus": {
      "PENDING": "Pendiente",
      "COMPLETED": "Completada",
      "EXPIRED": "Caducada",
      "CANCELLED": "Cancelada"
    },
    "subscribed": {
      "pending": "Invitación enviada; la suscripción empieza cuando {{email}} complete el registro.",
      "created": "Suscripción creada."
    },
    "subscribeDialog": {
      "title": "Suscribir",
      "email": "Correo",
      "emailRequired": "El correo es obligatorio.",
      "emailInvalid": "Introduce un correo válido.",
      "trialDays": "Días de prueba",
      "trialInvalid": "Debe ser cero o mayor.",
      "comp": "Cortesía",
      "until": "Cortesía hasta",
      "submit": "Suscribir",
      "cancel": "Cancelar"
    },
    "detail": {
      "title": "Suscripción",
      "entitlements": "Derechos",
      "statements": "Extractos",
      "payApi": "pay-api",
      "noPayApi": "Sin registro pay-api",
      "close": "Cerrar",
      "loadError": "No se pudo cargar esta suscripción."
    },
    "entitlement": {
      "kind": "Tipo",
      "status": "Estado",
      "startsAt": "Inicio",
      "endsAt": "Fin",
      "sponsor": "Patrocinador"
    },
    "field": {
      "id": "Id",
      "userId": "Id de usuario",
      "email": "Correo",
      "displayName": "Nombre",
      "status": "Estado",
      "origin": "Origen",
      "retailOfferId": "Oferta",
      "promotion": "Promoción",
      "trialEndsOn": "Fin de prueba",
      "compedUntil": "Cortesía hasta",
      "currentPeriodStart": "Inicio del periodo",
      "currentPeriodEnd": "Fin del periodo",
      "nextBillingOn": "Próximo cobro",
      "cardBrand": "Marca de tarjeta",
      "maskedCard": "Tarjeta enmascarada",
      "payApiSubscriptionId": "Id pay-api",
      "reconciledAt": "Conciliada",
      "createdBy": "Creada por",
      "createdAt": "Creada",
      "updatedAt": "Actualizada"
    },
    "payApi": {
      "subscriptionId": "Id",
      "status": "Estado",
      "planMappingId": "Asignación de plan",
      "contactRef": "Contacto",
      "verticalRef": "Vertical",
      "createdAt": "Creada",
      "nextBillingOn": "Próximo cobro",
      "pauseEffectiveOn": "Pausa efectiva",
      "cardBrand": "Marca de tarjeta",
      "maskedCard": "Tarjeta enmascarada",
      "pspSubscriptionId": "Id PSP"
    },
    "actions": {
      "cancel": "Cancelar…",
      "changeOffer": "Cambiar oferta…",
      "comp": "Cortesía…",
      "applyPromotion": "Aplicar promoción…",
      "endPromotion": "Terminar promoción",
      "aiSuspension": "Suspensión de IA",
      "moveToCurrent": "Mover a la versión actual…"
    },
    "move": {
      "title": "¿Mover a la versión actual?",
      "consequence": "{{subscriber}} pasa a {{card}} v{{version, number}} (la versión actual). Se envía un aviso. Si ya está en ella, no cambia nada.",
      "confirm": "Mover",
      "moved": "Movido a v{{version, number}}. Se envió un aviso.",
      "already": "Ya está en la versión actual. No cambió nada.",
      "failed": "El traslado no se completó. Inténtalo de nuevo; se puede repetir sin problema.",
      "error": "No se pudo mover esta suscripción."
    },
    "cancel": {
      "title": "Cancelar suscripción",
      "titleNamed": "¿Cancelar la suscripción de {{subscriber}}?",
      "mode": "Modo",
      "at_period_end": "Al final del periodo",
      "immediate": "Inmediata",
      "confirm": "Cancelar suscripción",
      "resultStatus": "Estado",
      "endsAt": "Termina el",
      "error": "No se pudo cancelar la suscripción.",
      "keep": "Conservar la suscripción",
      "consequence": {
        "at_period_end": "No se renovará. El suscriptor conserva el acceso hasta el final del periodo actual.",
        "immediate": "El suscriptor pierde el acceso ahora y es posible que se emitan un extracto y un cargo finales."
      }
    },
    "changeOffer": {
      "title": "Cambiar oferta",
      "offer": "Oferta",
      "offerN": "Oferta {{id}}",
      "submit": "Cambiar",
      "none": "Ninguna oferta se puede elegir en este momento.",
      "unselectable_one": "{{count, number}} oferta no se puede elegir",
      "unselectable_other": "{{count, number}} ofertas no se pueden elegir",
      "reasonNotActive": "{{name}}: su tarifario no está activo.",
      "closed": "{{name}}: esta versión de la oferta está cerrada.",
      "unexplained": "{{name}} no se puede elegir en este momento.",
      "loadError": "No se pudieron cargar las ofertas.",
      "offerInactive": "Esta oferta ya no está activa. Elige otra.",
      "error": "No se pudo cambiar la oferta."
    },
    "comp": {
      "title": "Cortesía de suscripción",
      "until": "Hasta",
      "submit": "Cortesía",
      "error": "No se pudo dar la suscripción de cortesía."
    },
    "promotion": {
      "applyTitle": "Aplicar promoción",
      "code": "Código",
      "codeRequired": "El código es obligatorio.",
      "apply": "Aplicar",
      "endTitle": "Terminar promoción",
      "codeName": "{{code}} · {{name}}",
      "termsPercent": "{{pct}} de descuento en el uso",
      "termsAmount": "{{amount}} de descuento en el uso por extracto",
      "termsOffer": "Precio de la oferta promocional",
      "statementsLeft_one": "{{count, number}} extracto restante",
      "statementsLeft_other": "{{count, number}} extractos restantes",
      "untilEnded": "Hasta que se termine",
      "appliedOn": "Aplicada el {{date}}",
      "endBodyVariable": "¿Terminar {{code}} para {{subscriber}}? El descuento se detiene a partir del próximo extracto. Los extractos ya emitidos lo conservan. Puedes volver a aplicar el código más adelante mientras siga siendo válido.",
      "endBodyOffer": "¿Terminar {{code}} para {{subscriber}}? Su precio no cambia. Esto te permite aplicar un código distinto.",
      "endConfirm": "Terminar promoción",
      "error": "No se pudo aplicar la promoción.",
      "endError": "No se pudo terminar la promoción.",
      "endKeep": "Conservar la promoción"
    },
    "ai": {
      "title": "Suspensión de IA",
      "suspended": "IA suspendida por la plataforma",
      "reason": "Motivo",
      "reasonRequired": "El motivo es obligatorio.",
      "confirm": "Confirmar",
      "error": "No se pudo cambiar la suspensión de IA."
    },
    "emailHint": "Busca por correo electrónico",
    "subscribeError": "No se pudo crear la suscripción."
  },
  "statements": {
    "tableAria": "Extractos del tenant",
    "copyDetailsAria": "Copiar detalles para soporte del extracto {{id, number}}",
    "loadError": "No se pudieron cargar los extractos.",
    "empty": "No hay extractos.",
    "periodFilter": "Periodo",
    "periodInvalid": "Usa AAAA-MM.",
    "statusFilter": "Estado",
    "statusAll": "Todos",
    "expand": "Expandir líneas",
    "collapse": "Contraer líneas",
    "retry": "Reintentar",
    "waive": "Condonar…",
    "col": {
      "period": "Periodo",
      "status": "Estado",
      "renewal": "Renovación",
      "seats": "Asientos",
      "tax": "Impuesto",
      "total": "Total",
      "attempts": "Intentos",
      "actions": "Acciones"
    },
    "lines": {
      "kind": "Tipo",
      "description": "Descripción",
      "quantity": "Cantidad",
      "unit": "Unidad",
      "amount": "Importe",
      "reference": "Referencia"
    },
    "kind": {
      "RENEWAL": "Renovación",
      "SEAT": "Asiento",
      "AI": "IA",
      "PROMOTION": "Promoción",
      "TAX": "Impuesto",
      "CONNECTED": "Cuentas conectadas"
    },
    "chargeStatus": {
      "NONE": "Ninguno",
      "PENDING": "Pendiente",
      "PAID": "Pagado",
      "ACTION_REQUIRED": "Acción requerida",
      "FAILED": "Fallido",
      "ATTENTION": "Atención",
      "WAIVED": "Condonado"
    },
    "waiveDialog": {
      "title": "Condonar extracto",
      "reason": "Motivo",
      "reasonRequired": "El motivo es obligatorio.",
      "submit": "Condonar"
    },
    "retryError": "No se pudo reintentar el extracto.",
    "waiveError": "No se pudo condonar el extracto."
  },
  "seats": {
    "tableAria": "Asientos del tenant",
    "loadError": "No se pudieron cargar los asientos.",
    "empty": "No hay asientos de invitado.",
    "sponsorFilter": "Id de patrocinador",
    "col": {
      "guest": "Invitado",
      "sponsor": "Patrocinador",
      "status": "Estado",
      "since": "Desde",
      "ends": "Termina"
    },
    "status": {
      "ACTIVE": "Activo",
      "ENDING": "Terminando",
      "ENDED": "Terminado"
    }
  },
  "revenue": {
    "empty": "No hay ingresos en este período.",
    "loadError": "No se pudieron cargar los ingresos.",
    "tableAria": "Ingresos por tenant",
    "breakdownAria": "Ingresos por tipo de línea",
    "expand": "Expandir tipos de línea",
    "collapse": "Contraer tipos de línea",
    "kpi": {
      "retail": "Minorista",
      "wholesale": "Mayorista (nuestro precio)",
      "tax": "Impuesto",
      "refunds": "Reembolsos",
      "resellerMargin": "Margen del revendedor",
      "resellerNet": "Neto del revendedor"
    },
    "col": {
      "tenant": "Tenant",
      "retail": "Minorista",
      "wholesale": "Mayorista (nuestro precio)",
      "tax": "Impuesto",
      "refunds": "Reembolsos",
      "line": "Línea",
      "resellerMargin": "Margen del revendedor",
      "resellerNet": "Neto del revendedor (después de afiliados)"
    },
    "line": {
      "BASE": "Suscripciones",
      "SEAT": "Asientos de invitado",
      "CONNECTED": "Cuentas conectadas",
      "AI": "IA",
      "TAX": "Impuesto"
    },
    "afterAffiliates": "después de afiliados"
  },
  "payouts": {
    "empty": "No hay extractos de pago.",
    "loadError": "No se pudo cargar la hoja de pagos.",
    "csvError": "No se pudo descargar el CSV.",
    "tableAria": "Hoja de pagos",
    "linesAria": "Líneas del extracto",
    "expand": "Expandir líneas",
    "collapse": "Contraer líneas",
    "downloadCsv": "Descargar CSV",
    "summary_one": "{{count, number}} extracto · {{payable}} a pagar · {{holds, number}} en espera",
    "summary_other": "{{count, number}} extractos · {{payable}} a pagar · {{holds, number}} en espera",
    "status": {
      "PENDING": "Pendiente",
      "CARRIED": "Trasladado",
      "PAID": "Pagado",
      "groupAria": "Estado de pago",
      "CHARGED": "Cobrado",
      "RETAINED": "Retenido"
    },
    "col": {
      "payee": "Beneficiario",
      "tenant": "Tenant",
      "period": "Período",
      "gross": "Bruto",
      "carriedIn": "Trasladado",
      "payable": "A pagar",
      "method": "Método",
      "hold": "Retención",
      "status": "Estado",
      "paid": "Pagado",
      "actions": "Acciones",
      "collected": "Cobrado",
      "kind": "Tipo",
      "line": "Línea",
      "retail": "Minorista",
      "wholesale": "Mayorista",
      "uplift": "Incremento",
      "tenantShare": "Participación del tenant",
      "platform": "Plataforma",
      "shareApplied": "Participación aplicada",
      "commission": "Comisión",
      "payApiRef": "ref. pay-api"
    },
    "payee": {
      "RESELLER": "Revendedor",
      "AFFILIATE": "Afiliado"
    },
    "method": {
      "MANUAL": "Manual",
      "STRIPE_CONNECT_MANUAL": "Stripe Connect (pagos manuales)",
      "STRIPE_CONNECT": "Stripe Connect (pagos automáticos)"
    },
    "hold": {
      "HOLD_TAX_DOCS": "Documentos fiscales",
      "HOLD_STRIPE_CONNECT": "Stripe Connect",
      "HOLD_TRANSFER_CURRENCY": "Moneda de transferencia",
      "HOLD_TRANSFER_CAP": "Límite de transferencia",
      "HOLD_RESELLER_UNPAID": "Cargo del revendedor impago",
      "HOLD_AFFILIATE_REVIEW": "Retenido para revisión (afiliado terminado por causa)"
    },
    "kind": {
      "RENEWAL": "Renovación",
      "VARIABLE": "Variable",
      "REFUND": "Reembolso",
      "AFFILIATE_COMMISSION": "Comisión de afiliado",
      "ADDON_FEE": "Cargo de complemento",
      "BOUNTY": "Bonos de captación de afiliado",
      "MILESTONE": "Hitos de afiliado",
      "CLAWBACK": "Reversión",
      "RECOVERY": "Reversiones recuperadas"
    },
    "record": {
      "action": "Registrar pago…",
      "title": "Registrar pago",
      "amount": "Importe",
      "paidAt": "Pagado el",
      "ref": "Referencia",
      "refRequired": "La referencia es obligatoria.",
      "override": "Registrar otro importe",
      "overrideHelp": "Solo si el importe pagado difiere del importe a pagar; indica un motivo.",
      "reason": "Motivo",
      "reasonRequired": "El motivo es obligatorio.",
      "submit": "Registrar",
      "cancel": "Cancelar",
      "recorded": "Pago registrado.",
      "failed": "No se pudo registrar el pago.",
      "holdInfo": "En espera ({{hold}}); aún se puede registrar.",
      "refusedHold": "No se puede registrar mientras: {{hold}}.",
      "holdUnknown": "en espera",
      "notPayable": "Esta liquidación se cobró a la tarjeta del revendedor; no hay nada que pagar."
    },
    "allTenants": "Todos los tenants",
    "paidViaPrefix": "pagado mediante",
    "tenantCaptionNoReseller": "Los pagos van al revendedor del tenant una vez asignado. Los extractos que se muestran aquí son anteriores a ese cambio, además de los extractos de afiliados.",
    "tenantCaptionPrefix": "Los pagos van al revendedor del tenant — consulta ",
    "tenantCaptionReseller": "Liquidaciones de {{resellerName}}",
    "tenantCaptionSuffix": ". Los extractos que se muestran aquí son anteriores a ese cambio, además de los extractos de afiliados.",
    "unattributed": {
      "alert": "Ingresos aún no atribuidos a un revendedor: {{amounts}}",
      "row": "{{rows, number}} filas · {{retail}}"
    },
    "exportsStatus": "Exporta los extractos: {{status}}"
  },
  "ai": {
    "asOf": "A fecha de {{date}}",
    "add": "Añadir modelo…",
    "added": "Precio añadido.",
    "changed": "Precio cambiado.",
    "changePrice": "Cambiar precio…",
    "changePriceFor": "Cambiar precio de {{name}} ({{currency}})",
    "tabs": {
      "models": "Modelos",
      "fast": "Asignación del nivel rápido",
      "deep": "Asignación del nivel profundo",
      "aria": "Secciones de precios de modelos de IA",
      "naming": "Calidad de los nombres"
    },
    "scheduled": "Programado",
    "priceInUse": "Una asignación de modelo depende de este precio. Cambia o retira esa asignación primero.",
    "withdrawPriceFor": "Retirar el precio que empieza {{when}}",
    "withdrawPriceTitle": "Retirar un precio programado",
    "withdrawPriceQuestion": "¿Retirar el precio que empieza {{when}}?",
    "models": {
      "caption": "Qué modelo llama cada nivel. Los cambios se aplican a las llamadas de IA que empiezan después.",
      "fast": "Nivel rápido",
      "deep": "Nivel profundo",
      "emptyCurrent": "Sin modelo. La IA de este nivel está apagada hasta que se asigne uno.",
      "priced": "Con precio en {{currencies}}.",
      "missing": "{{model}} no tiene precio en {{currencies}}, así que las llamadas de IA en esas monedas se rechazan.",
      "addPrice": "Añade el precio en la pestaña Modelos.",
      "field": "Modelo",
      "fieldHelp": "El modelo que llama este nivel.",
      "notPriced": "{{model}} no tiene un precio en vigor en ese momento en {{currencies}}. Añade el precio primero y vuelve a programar.",
      "loadError": "No se pudieron cargar las asignaciones de modelos.",
      "tierMissing": "Este nivel no está disponible.",
      "notOnTier": "Ese modelo no está permitido en este nivel. Marca primero el nivel en la pestaña Modelos.",
      "noneOnTier": "No hay modelos permitidos en este nivel. Añade uno en la pestaña Modelos, con este nivel marcado.",
      "openModels": "Abrir la pestaña Modelos",
      "effort": "Esfuerzo",
      "effortHelp": "Cuánto piensa el modelo antes de responder. Más esfuerzo cuesta más y puede quedarse sin espacio para la respuesta. Rápido usa Bajo por defecto; Profundo, Medio.",
      "effortVerifyHint": "Verifica este modelo en la pestaña Modelos para elegir otro esfuerzo.",
      "effortNotTaken": "Este modelo no admite ese esfuerzo.",
      "effortVerify": "Verifica el modelo en la pestaña Modelos para elegir otro esfuerzo.",
      "modelRetired": "Anthropic ha retirado este modelo. Elige otro.",
      "effortNone": "Este modelo no admite ningún nivel de esfuerzo. Elige otro modelo.",
      "noEffortWarning": "Anthropic ya no indica que este modelo admita esfuerzo; programa otro modelo.",
      "notVerifiedStructured": "Sin verificar para salida estructurada. Verifícalo antes de asignarlo.",
      "noStructuredWarning": "Anthropic indica que este modelo ya no admite salidas estructuradas; programa otro modelo.",
      "modelNoStructured": "Este modelo no admite salidas estructuradas. Elige otro.",
      "modelVerifyFirst": "Verifica primero este modelo.",
      "verifyModel": "Verificar {{model}}"
    },
    "loadError": "No se pudieron cargar los modelos de IA y sus precios.",
    "inForce": "En vigor",
    "showHistory": "Mostrar historial",
    "hideHistory": "Ocultar historial",
    "col": {
      "model": "Modelo",
      "currency": "Moneda",
      "effectiveFrom": "Vigente desde",
      "inForce": "En vigor",
      "input": "Entrada / Mtok",
      "output": "Salida / Mtok",
      "cacheRead": "Lectura de caché / Mtok",
      "cacheWrite": "Escritura de caché / Mtok",
      "added": "Añadido"
    },
    "form": {
      "title": "Añadir precio: {{name}}",
      "addExplain": "Fija el precio en una moneda.",
      "model": "Modelo",
      "currency": "Moneda",
      "input": "Entrada / Mtok",
      "output": "Salida / Mtok",
      "cacheRead": "Lectura de caché / Mtok",
      "cacheWrite": "Escritura de caché / Mtok",
      "microCaption": "Envía {{micro}} microunidades / Mtok",
      "submit": "Añadir precio",
      "changeSubmit": "Cambiar precio",
      "changeTitle": "Cambiar precio: {{name}} ({{currency}})",
      "changeExplain": "Los precios no se editan en el sitio. Esto inicia un precio nuevo; el uso de IA anterior conserva el precio con el que se cobró.",
      "fromDate": "Desde una fecha",
      "dateRequired": "Elige una fecha.",
      "dateAfterToday": "Elige una fecha posterior a hoy, o elige Ahora.",
      "outputAboveInput": "La salida debe costar más que la entrada.",
      "saveAnyway": "Guardar de todos modos",
      "warn": {
        "cacheRead": "La lectura de caché suele costar menos que la entrada.",
        "cacheWrite": "La escritura de caché suele costar más que la entrada.",
        "moved": "{{rate}} cambia de {{from}} a {{to}}."
      },
      "cancel": "Cancelar",
      "required": "Obligatorio.",
      "error": "No se pudo añadir el precio.",
      "moreThanZero": "Debe ser mayor que cero.",
      "modelNotInCatalogue": "Este modelo no está en el catálogo. Añade primero el modelo en la pestaña Modelos."
    },
    "attention": {
      "loadError": "No se pudo cargar la atención de facturación.",
      "none": "Ninguno.",
      "tabsAria": "Secciones de atención de facturación",
      "tabCount": "{{label}} ({{count, number}})",
      "tab": {
        "statements": "Extractos",
        "divergences": "Divergencias",
        "parked": "Eventos de cobro en espera",
        "tax": "Clasificación fiscal"
      },
      "parked_one": "Eventos de cobro en espera ({{count, number}})",
      "parked_other": "Eventos de cobro en espera ({{count, number}})",
      "statementsAria": "Extractos que requieren atención",
      "divergencesAria": "Divergencias de conciliación",
      "parkedAria": "Eventos de cobro en espera",
      "feedStalled": "El flujo de cobros está detenido desde {{since}}. Un bloqueo impide aplicar el evento {{seq, number}}.",
      "lastAttemptFailed": "El último intento falló.",
      "copyDetails": "Copiar detalles para soporte",
      "copyDetailsAria": "Copiar detalles para soporte del extracto {{id, number}}",
      "col": {
        "period": "Periodo",
        "status": "Estado",
        "total": "Total",
        "attempts": "Intentos",
        "lastError": "Último error",
        "subscriptionId": "Id de suscripción",
        "payApi": "suscripción pay-api",
        "fields": "Campos",
        "seq": "Seq",
        "eventType": "Tipo de evento",
        "appliedAt": "Aplicado el",
        "count": "Cantidad",
        "oldest": "Más antiguo",
        "product": "Producto",
        "since": "Desde",
        "details": "Detalles",
        "charge": "Cobro",
        "chargeId": "Id del cobro",
        "tenantId": "Id del tenant",
        "resellerId": "Id del revendedor",
        "failedAt": "Falló el"
      },
      "declare": {
        "action": "Declarar productos…",
        "title": "¿Enviar de nuevo la lista de productos de tmm a pay-api?",
        "body": "Es seguro repetirlo.",
        "confirm": "Declarar productos",
        "done": "Productos declarados.",
        "error": "No se pudieron declarar los productos.",
        "someFailed": "No se pudieron declarar algunos productos. Inténtalo de nuevo; es seguro repetirlo."
      },
      "unhandled": {
        "title": "Eventos de cobro sin gestionar",
        "note": "Eventos de cobro que tmm-api aún no gestiona. Se conservan y se aplican cuando una versión los gestione.",
        "aria": "Eventos de cobro sin gestionar"
      },
      "skuReview": {
        "title": "Productos por revisar",
        "note": "Revisa la clasificación fiscal del producto en el registro de pay-api.",
        "aria": "Productos por revisar",
        "copyAria": "Copiar detalles para soporte del producto {{identifier}}"
      },
      "taxClassification": {
        "note": "Un producto necesita una clasificación fiscal en pay-api antes de poder cobrarse.",
        "aria": "Clasificación fiscal requerida",
        "copyAria": "Copiar detalles para soporte del cobro {{id}}"
      },
      "sku": {
        "tmm_subscription": "Suscripción",
        "tmm_guests": "Invitados",
        "tmm_connections": "Conexiones",
        "tmm_ai_wallet_credit": "Crédito del monedero de IA",
        "tmm_partner_addon_custom_ui": "Complemento de socio: interfaz personalizada",
        "tmm_partner_addon_mobile_app": "Complemento de socio: app móvil",
        "tmm_partner_minimum_shortfall": "Déficit del mínimo del socio",
        "tmm_partner_statement_deficit": "Déficit del extracto del socio"
      },
      "chargeKind": {
        "WALLET_CHARGE": "Cobro del monedero de IA",
        "ADDON_CHARGE": "Cobro de complemento",
        "RESELLER_CHARGE": "Cobro de revendedor"
      }
    },
    "effort": {
      "LOW": "Bajo",
      "MEDIUM": "Medio",
      "HIGH": "Alto",
      "XHIGH": "Muy alto",
      "MAX": "Máximo"
    },
    "catalog": {
      "tier": {
        "FAST": "Rápido",
        "DEEP": "Profundo"
      },
      "and": " y ",
      "inUse": "El nivel {{tiers}} usa este modelo. Asigna primero otro modelo allí.",
      "inUseNoTiers": "Un nivel usa este modelo. Asigna primero otro modelo allí.",
      "unavailable": "No pudimos contactar con Anthropic para comprobar el modelo. No se guardó nada. Inténtalo de nuevo en un momento.",
      "form": {
        "tiers": "Niveles",
        "tierRequired": "Elige al menos un nivel.",
        "modelId": "Id del modelo",
        "modelIdRule": "Minúsculas, números, puntos y guiones. Exactamente como lo llama Anthropic."
      },
      "notAtProvider": "Anthropic no conoce ese id de modelo. Revisa cómo está escrito.",
      "exists": "Ese modelo ya está en el catálogo.",
      "add": {
        "title": "Añadir modelo",
        "submit": "Añadir modelo",
        "consequence": "Comprobamos el id con Anthropic antes de guardarlo.",
        "error": "No se pudo añadir el modelo."
      },
      "added": "{{model}} añadido.",
      "edit": {
        "title": "Editar niveles: {{model}}",
        "submit": "Guardar",
        "saved": "Niveles guardados.",
        "error": "No se pudieron cambiar los niveles."
      },
      "notFound": "No se encontró ese modelo.",
      "retire": {
        "action": "Dar de baja…",
        "title": "Dar de baja un modelo",
        "question": "¿Dar de baja {{model}}? Sus precios e historial se conservan.",
        "confirm": "Dar de baja",
        "error": "No se pudo dar de baja el modelo."
      },
      "retired": "{{model}} dado de baja.",
      "retiredLine": "Dado de baja el {{date}} por {{who}}",
      "verify": "Verificar",
      "verified": "Comprobado con Anthropic.",
      "checking": "Comprobando con Anthropic…",
      "goneAtProvider": "Anthropic ya no conoce este modelo. No se ha dado de baja; dalo de baja cuando nada lo use.",
      "verifyError": "No se pudo comprobar el modelo.",
      "notVerified": "Sin verificar",
      "pricesFor": "Precios de {{model}}",
      "noPrices": "Aún no hay precios. Añade uno antes de asignar este modelo.",
      "showPrices": "Mostrar precios de {{model}}",
      "hidePrices": "Ocultar precios de {{model}}",
      "addPrice": "Añadir precio…",
      "addPriceFor": "Añadir precio para {{model}}",
      "editTiers": "Editar niveles…",
      "showRetired": "Mostrar dados de baja",
      "empty": "Aún no hay modelos. Añade uno para ponerle precio y asignarlo a un nivel.",
      "tableAria": "Catálogo de modelos de IA",
      "col": {
        "tiers": "Niveles",
        "usedBy": "En uso por",
        "verified": "Verificado",
        "efforts": "Esfuerzos",
        "structured": "Salida estructurada"
      },
      "showOutside_one": "Mostrar {{count, number}} precio de modelos fuera del catálogo",
      "showOutside_other": "Mostrar {{count, number}} precios de modelos fuera del catálogo",
      "hideOutside": "Ocultar precios de modelos fuera del catálogo",
      "outsideCaption": "No se pueden asignar. Añade el modelo al catálogo para usarlo.",
      "outsideAria": "Precios de modelos fuera del catálogo",
      "unavailableAuth": "Anthropic rechazó nuestra clave de API. Pide al operador de la plataforma que revise la clave; no se guardó nada.",
      "notSupported": {
        "RETIRED": "Anthropic ha retirado ese modelo. No se puede añadir.",
        "NO_EFFORT": "Ese modelo no admite un nivel de esfuerzo, que toda llamada de IA envía. No se puede añadir.",
        "NO_STRUCTURED_OUTPUT": "Ese modelo no admite salidas estructuradas, que toda llamada de IA necesita. No se puede añadir."
      },
      "effortsNotChecked": "Sin comprobar",
      "effortsHint": "Verificar lo completa.",
      "effortsNone": "Ninguno (no se puede asignar)",
      "noEffortChip": "Sin esfuerzo admitido",
      "noEffortReason": "Anthropic indica que este modelo no admite esfuerzo; no se puede asignar.",
      "structuredYes": "Sí",
      "structuredNo": "No (no se puede asignar)",
      "structuredNotChecked": "Sin comprobar",
      "structuredHint": "Verificar lo completa.",
      "noStructuredChip": "Sin salida estructurada",
      "noStructuredReason": "Anthropic indica que este modelo no admite salidas estructuradas; no se puede asignar.",
      "lifecycle": {
        "retiresOn": "Se retira el {{date}}",
        "deprecated": "Obsoleto",
        "retired": "Retirado por Anthropic"
      },
      "retiredGroup": "Modelos dados de baja",
      "retiredCaption": "Este modelo está dado de baja. Vuelve a añadirlo en esta pestaña para usarlo; sus precios se conservan.",
      "retiredAria": "Precios de modelos dados de baja"
    }
  },
  "parkedEvents": {
    "retention": "Volver a aplicar funciona durante 90 días después del evento de cobro.",
    "tabsAria": "Eventos de cobro en espera por resolución",
    "tab": {
      "unresolved": "Sin resolver",
      "resolved": "Resueltos"
    },
    "tableAria": "Eventos de cobro en espera",
    "regionAria": "Lista de eventos de cobro en espera",
    "loadError": "No se pudieron cargar los eventos de cobro en espera.",
    "empty": "No hay eventos de cobro en espera.",
    "emptyResolved": "Todavía no hay nada resuelto.",
    "col": {
      "parked": "En espera desde",
      "event": "Evento",
      "reason": "Motivo",
      "attempts": "Intentos",
      "payment": "Cobro",
      "subscription": "Suscripción",
      "resolution": "Resolución",
      "resolved": "Resuelto",
      "by": "Por",
      "note": "Nota",
      "actions": "Acciones"
    },
    "eventType": {
      "subscription_renewed": "Suscripción renovada",
      "subscription_payment_failed": "Cobro de la suscripción fallido",
      "subscription_canceled": "Suscripción cancelada",
      "subscription_activated": "Suscripción activada",
      "subscription_payment_method_updated": "Método de pago actualizado",
      "subscription_paused": "Suscripción en pausa",
      "subscription_resumed": "Suscripción reanudada",
      "subscription_plan_changed": "Plan cambiado",
      "subscription_renewal_upcoming": "Renovación próxima",
      "payment_succeeded": "Cobro realizado",
      "payment_failed": "Cobro fallido",
      "payment_refunded": "Cobro reembolsado",
      "connect_account_updated": "Cuenta conectada actualizada",
      "transfer_created": "Transferencia creada",
      "transfer_failed": "Transferencia fallida",
      "transfer_reversed": "Transferencia revertida",
      "transfer_reversal_failed": "Reversión de la transferencia fallida"
    },
    "reason": {
      "REFUND_EXCEEDS_PAYMENT": "El reembolso es mayor que el cobro.",
      "REFUND_CURRENCY_MISMATCH": "La moneda del reembolso es distinta de la del cobro.",
      "REFUND_PARENT_MISSING": "El reembolso no indica a qué cobro corresponde.",
      "REFUND_PARENT_NOT_MIRRORED": "El cobro original aún no está registrado. Vuelve a aplicar el evento cuando lo esté.",
      "REFUND_CURRENCY_MISSING": "El reembolso no tiene moneda.",
      "REFUND_FIELDS_MISSING": "Al reembolso le faltan datos obligatorios.",
      "DISPUTE_FIELDS_MISSING": "A la disputa le faltan datos obligatorios.",
      "HANDLER_FAILED": "Falló tres veces al aplicarlo."
    },
    "reasonUnknown": "No se pudo aplicar el evento.",
    "resolution": {
      "REAPPLIED": "Reaplicado",
      "DISMISSED": "Descartado"
    },
    "reapply": {
      "title": "¿Volver a aplicar el evento {{seq, number}}?",
      "consequence": "tmm-api lo obtiene de pay-api y lo aplica una sola vez.",
      "confirm": "Volver a aplicar",
      "rowAria": "Volver a aplicar el evento {{seq, number}}",
      "done": "Evento reaplicado.",
      "failed": "No se pudo volver a aplicar el evento.",
      "stillRefused": "Se rechazó de nuevo: {{reason}}.",
      "payApiUnavailable": "pay-api no está disponible en este momento, así que no se puede obtener el evento. Inténtalo de nuevo más tarde."
    },
    "dismiss": {
      "title": "¿Descartar el evento {{seq, number}}?",
      "consequence": "No se aplica nada. Úsalo cuando se gestionó en otro lugar, o cuando el miembro fue borrado.",
      "confirm": "Descartar",
      "rowAria": "Descartar el evento {{seq, number}}",
      "done": "Evento descartado.",
      "failed": "No se pudo descartar el evento."
    },
    "dismissInstead": "Descartar en su lugar",
    "lastRefusal": "Último intento de volver a aplicar rechazado hace un momento: {{reason}}",
    "dialog": {
      "note": "Nota",
      "counter": "{{count, number}}/{{max, number}}",
      "noteRule": "Escribe una nota de 3 a 500 caracteres."
    },
    "support": {
      "label": "Detalles para soporte",
      "rowAria": "Copiar los detalles para soporte del evento {{seq, number}}"
    }
  },
  "deletions": {
    "empty": "No hay solicitudes de eliminación.",
    "loadError": "No se pudieron cargar las solicitudes de eliminación.",
    "requested": "Eliminación solicitada.",
    "cancelled": "Solicitud de eliminación cancelada.",
    "tableAria": "Solicitudes de eliminación",
    "requestedBy": "por {{who}}",
    "copyDetailsAria": "Copiar detalles para soporte de la solicitud de eliminación {{id, number}}",
    "cancel": "Cancelar…",
    "counter": "{{n, number}}/200",
    "col": {
      "person": "Persona",
      "requested": "Solicitada",
      "coolingOff": "Enfriamiento hasta",
      "status": "Estado",
      "erasedAt": "Borrada el",
      "attempts": "Intentos",
      "actions": "Acciones"
    },
    "status": {
      "PENDING": "Pendiente",
      "CANCELLED": "Cancelada",
      "ERASING": "Borrando",
      "ERASED": "Borrada",
      "FAILED": "Fallida"
    },
    "request": {
      "action": "Solicitar eliminación…",
      "warning": "Todo lo que esta persona posee se borra después del periodo de enfriamiento. Se le envía un correo y puede cancelar.",
      "error": "No se pudo solicitar la eliminación."
    },
    "requestDialog": {
      "title": "Solicitar eliminación",
      "person": "Persona",
      "personRequired": "La persona es obligatoria.",
      "reason": "Motivo",
      "reasonRequired": "El motivo es obligatorio.",
      "submit": "Solicitar",
      "cancel": "Cancelar"
    },
    "cancelDialog": {
      "titleNamed": "¿Cancelar la solicitud de eliminación de {{person}}?",
      "consequence": "No se borrará nada de lo que esta persona posee.",
      "reason": "Motivo",
      "confirm": "Cancelar eliminación",
      "error": "No se pudo cancelar la solicitud de eliminación.",
      "keep": "Conservar la solicitud de eliminación"
    },
    "erase": {
      "action": "Borrar ahora…",
      "title": "¿Borrar esta cuenta ahora?",
      "body": "Esto elimina de forma permanente los datos de {{person}} ahora, en lugar de en la fecha programada. No se puede deshacer.",
      "confirm": "Borrar ahora",
      "erased": "Cuenta borrada.",
      "retrying": "El borrado comenzó; terminará en segundo plano.",
      "cancelledError": "Esta solicitud se canceló, así que no se puede borrar.",
      "notFoundError": "Esta solicitud ya no existe.",
      "error": "No se pudo borrar la cuenta.",
      "retryTitle": "¿Intentar borrar esta cuenta de nuevo?",
      "retryBody": "El último intento falló. Esto lo intenta de nuevo ahora y no se puede deshacer una vez que lo consiga.",
      "failedAgain": "El borrado volvió a fallar: {{reason}}."
    },
    "errorCode": {
      "ASSOCIATION_HOLD": "Todavía no se pudo asociar la suscripción de la cuenta en pay-api.",
      "PAY_API_UNAVAILABLE": "pay-api no respondió.",
      "PAY_API_REFUSED": "pay-api rechazó la solicitud.",
      "ERASURE_IN_PROGRESS": "pay-api todavía está borrando los registros de pago.",
      "IDEMPOTENCY_CONFLICT": "pay-api informó de un conflicto en la solicitud de borrado.",
      "STEP_FAILED": "Falló un paso del borrado.",
      "UNKNOWN": "El borrado falló."
    }
  },
  "aiUsage": {
    "tabs": {
      "aria": "Secciones de uso de IA",
      "features": "Por función",
      "people": "Por persona"
    },
    "empty": "No hay uso de IA en este periodo.",
    "loadError": "No se pudo cargar el uso de IA.",
    "range": "{{from}} – {{to}}",
    "showing": "Mostrando {{person}}",
    "details": "Detalles",
    "atOurPriceAbsent": "— significa que ninguna oferta pone precio a este uso a nuestro precio.",
    "atOurPricePartial": "Parcial",
    "atOurPricePartialHelp": "— significa que ninguna oferta pone precio a este uso a nuestro precio. Parcial significa que el uso de algunas personas no tiene precio a nuestro precio, así que no se muestra un total.",
    "kpi": {
      "requests": "Solicitudes",
      "failed": "Fallidas",
      "totalTokens": "Tokens totales"
    },
    "tableAria": {
      "features": "Uso de IA por función",
      "people": "Uso de IA por persona"
    },
    "col": {
      "feature": "Función",
      "requests": "Solicitudes",
      "failed": "Fallidas",
      "input": "Entrada",
      "output": "Salida",
      "cacheRead": "Lectura de caché",
      "cacheWrite": "Escritura de caché",
      "totalTokens": "Tokens totales",
      "cost": "Costo",
      "atOurPrice": "A nuestro precio",
      "charge": "Cargo est.",
      "person": "Persona",
      "actions": "Acciones",
      "walletUsage": "Uso del monedero",
      "balance": "Saldo"
    },
    "feature": {
      "IMPORT_MAPPING": "Asignación de importación",
      "CATEGORY_SUGGESTION": "Sugerencia de categoría",
      "MEETING_SUMMARY": "Resumen de reunión",
      "MATCH_SUGGESTION": "Sugerencia de coincidencia",
      "DOMAIN_SETUP": "Configuración de dominio",
      "PAYEE_SUGGESTION": "Sugerencia de beneficiario",
      "PAYEE_PATTERN": "Patrones de beneficiario",
      "ENVELOPE_ANALYSIS": "Análisis de sobres",
      "FINANCIAL_ASSISTANT": "Mi Asistente Financiero",
      "SUPPORT_ASSISTANT": "Asistente de soporte"
    },
    "wallet": {
      "toggle": "Monedero",
      "purchases": "Compras",
      "recharges": "Recargas",
      "topUps": "Recargas manuales",
      "monthlyCredits": "Créditos mensuales",
      "adminCredits": "Créditos del administrador",
      "usage": "Uso",
      "balance": "Saldo"
    },
    "suspended": "IA suspendida por la plataforma",
    "suspendedSince": "Desde {{date}}",
    "credit": {
      "action": "Añadir crédito de IA…",
      "title": "Añadir crédito de IA para {{person}}",
      "amount": "Importe",
      "reason": "Motivo",
      "amountRule": "Escribe un importe mayor que cero y de como máximo 10,000,000.00.",
      "reasonRequired": "El motivo es obligatorio.",
      "reasonTooLong": "Usa como máximo 255 caracteres.",
      "consequence": "Se añaden {{amount}} al monedero de IA de {{person}}. Queda registrado con tu motivo.",
      "consequenceNoWallet": "Se añaden {{amount}} en la moneda de su suscripción al monedero de IA de {{person}}. Queda registrado con tu motivo.",
      "confirm": "Añadir crédito",
      "added": "Se añadieron {{amount}}. Su saldo de IA es {{balance}}.",
      "noSubscription": "Esta persona no tiene una suscripción activa, así que no se puede abonar su monedero de IA.",
      "keyConflict": "Este crédito ya se envió con otro importe. Cierra esto y empieza de nuevo.",
      "error": "No se pudo añadir el crédito de IA."
    }
  },
  "customers": {
    "invite": {
      "action": "Invitar cliente…",
      "title": "Invitar cliente",
      "email": "Correo",
      "emailRequired": "El correo es obligatorio.",
      "emailInvalid": "Introduce un correo válido.",
      "submit": "Invitar",
      "cancel": "Cancelar",
      "sent": "Invitación enviada a {{email}}.",
      "created": "Invitación creada para {{email}}; no se pudo enviar el correo.",
      "error": "No se pudo invitar al cliente."
    }
  },
  "paymentsSetup": {
    "title": "Configuración de cobros",
    "refresh": "Actualizar la configuración de cobros",
    "refreshing": "Actualizando la configuración de cobros…",
    "refreshed": "Configuración de cobros actualizada.",
    "refreshError": "No se pudo actualizar la configuración de cobros.",
    "refreshUnavailable": "pay-api no tiene una configuración de cobros para este tenant, o no se pudo conectar con él. Revisa el tenant en pay-api y vuelve a actualizar.",
    "loadError": "No se pudo cargar la configuración de cobros.",
    "empty": "No hay una configuración de cobros en caché para este tenant. Actualiza para leerla desde pay-api.",
    "field": {
      "provider": "Proveedor",
      "environment": "Entorno",
      "flow": "Flujo",
      "stripeAccount": "Cuenta de Stripe",
      "publishableKey": "Clave publicable"
    },
    "connection": {
      "label": "Conexión de cobros",
      "provisioned": "Aprovisionada el {{date}}",
      "notProvisioned": "Sin aprovisionar"
    },
    "provision": {
      "open": "Aprovisionar los cobros…",
      "title": "¿Aprovisionar los cobros de {{name}}?",
      "consequence": "Esto configura los cobros del tenant en la cuenta de Stripe de la plataforma, en pay-api, y los activa en {{currency}}. Los cargos fuera del rango configurado se rechazan. Se puede repetir sin riesgo.",
      "confirm": "Aprovisionar los cobros",
      "done": "Cobros aprovisionados.",
      "error": "No se pudieron aprovisionar los cobros.",
      "reason": {
        "CONNECTION_EXISTS": "Este tenant ya tiene otra conexión de cobros en pay-api: una cuenta conectada, otro proveedor o el otro entorno. Alguien debe quitarla en pay-api antes de poder aprovisionar los cobros aquí.",
        "STRIPE_ENVIRONMENT_UNSET": "El entorno de Stripe de tmm-api no está configurado, así que no se envió nada a pay-api. Consulta al equipo de la plataforma.",
        "HOUSE_MODE_NOT_ALLOWED": "pay-api todavía no permite que tmm cobre en la cuenta de Stripe de la plataforma. Consulta al equipo de la plataforma.",
        "HOUSE_MODE_UNAVAILABLE": "pay-api todavía no admite cobrar en la cuenta de Stripe de la plataforma. Consulta al equipo de la plataforma.",
        "ACTIVATION_REFUSED": "pay-api rechazó activar la conexión de cobros.",
        "PAY_API_UNAVAILABLE": "pay-api no está disponible en este momento. Inténtalo de nuevo; se puede repetir sin riesgo."
      }
    }
  },
  "whitelabel": {
    "title": "Dominio personalizado",
    "none": "Sin dominio personalizado. Los tenants usan los nombres de host de la plataforma.",
    "setUp": "Configurar un dominio…",
    "loadError": "No se pudo cargar el dominio personalizado.",
    "domain": "Dominio",
    "stateLabel": "Estado",
    "state": {
      "DRAFT": "Esperando DNS",
      "ACTIVE": "Activo"
    },
    "activatedAt": "Activado",
    "hostnames": "Nombres de host",
    "col": {
      "hostname": "Nombre de host",
      "type": "Tipo",
      "app": "App",
      "dns": "DNS"
    },
    "type": {
      "APP": "App",
      "LOGIN": "Inicio de sesión",
      "AUTH": "Autenticación",
      "API": "API",
      "ASSET": "Recursos",
      "BRAND": "Centro de marca"
    },
    "verified": "Verificado",
    "notVerified": "No verificado",
    "records": {
      "title": "Registros DNS que crear",
      "host": "Host",
      "type": "Tipo",
      "target": "Destino",
      "verified": "Verificado"
    },
    "copy": "Copiar {{value}}",
    "verify": "Verificar DNS",
    "verifying": "Verificando DNS",
    "verifyWait": "Esto puede tardar hasta un minuto.",
    "verifyError": "No se pudo verificar el DNS.",
    "results": {
      "title": "Última comprobación",
      "thisCheck": "Esta comprobación",
      "matched": "Coincide",
      "notMatched": "No coincide",
      "allVerified": "Todos los nombres de host están verificados.",
      "someFailed": "Algunos nombres de host no se verificaron. Revisa los registros DNS e inténtalo de nuevo."
    },
    "change": "Cambiar dominio…",
    "remove": "Quitar…",
    "removeTitle": "¿Quitar el dominio personalizado?",
    "removeBody": "El tenant vuelve a los nombres de host de la plataforma. Después puedes borrar los registros DNS que creaste.",
    "removeConfirm": "Quitar",
    "removed": "Dominio personalizado quitado.",
    "removeError": "No se pudo quitar el dominio personalizado.",
    "note": {
      "required": "Obligatorio",
      "optional": "Opcional"
    },
    "set": {
      "title": "Configurar un dominio",
      "changeTitle": "Cambiar dominio",
      "domainLabel": "Dominio",
      "domainHelper": "El dominio propio del cliente, p. ej. example.com",
      "domainRequired": "El dominio es obligatorio.",
      "domainTooLong": "El dominio debe tener 255 caracteres o menos.",
      "include": "Incluir",
      "includeHost": "Incluir {{prefix}}",
      "prefix": "Prefijo",
      "prefixFor": "Prefijo para {{prefix}}",
      "prefixRequired": "El prefijo es obligatorio.",
      "prefixTooLong": "El prefijo debe tener 63 caracteres o menos.",
      "note": "Nota",
      "noneChecked": "Elige al menos un nombre de host.",
      "templateError": "No se pudieron cargar los nombres de host sugeridos.",
      "saveError": "No se pudo guardar el dominio.",
      "saved": "Dominio guardado. Crea los registros DNS y luego verifica.",
      "cancel": "Cancelar",
      "save": "Guardar",
      "refused": "Ese dominio no se puede usar. Revísalo e inténtalo de nuevo.",
      "domainName": "el dominio personalizado"
    }
  },
  "addons": {
    "tabs": {
      "aria": "Secciones de complementos"
    },
    "catalog": {
      "title": "Catálogo",
      "tableAria": "Catálogo de complementos",
      "empty": "Todavía no hay nada en el catálogo.",
      "loadError": "No se pudo cargar el catálogo.",
      "col": {
        "name": "Nombre",
        "period": "Periodo",
        "price": "Precio",
        "billing": "Facturación",
        "status": "Estado",
        "actions": "Acciones"
      }
    },
    "fleet": {
      "title": "Complementos de los tenants",
      "statusAria": "Estado del complemento",
      "all": "Todos",
      "loadError": "No se pudieron cargar los complementos de los tenants.",
      "tableAria": "Complementos de los tenants",
      "empty": "No hay complementos de tenants."
    },
    "tenant": {
      "tableAria": "Complementos del tenant",
      "empty": "Este tenant no tiene complementos.",
      "loadError": "No se pudieron cargar los complementos.",
      "expand": "Mostrar cargos de {{name}}",
      "collapse": "Ocultar cargos de {{name}}",
      "cancels": "Se cancela el {{date}}"
    },
    "col": {
      "tenant": "Tenant",
      "addon": "Complemento",
      "status": "Estado",
      "billingMode": "Modo de facturación",
      "price": "Precio por periodo",
      "term": "Vigencia",
      "autoRenew": "Renovación automática",
      "revenueYear": "Ingresos de este año",
      "offered": "Ofrecido",
      "accepted": "Aceptado",
      "actions": "Acciones"
    },
    "charges": {
      "empty": "Todavía no hay cargos.",
      "tableAria": "Cargos de {{name}}",
      "copyDetailsAria": "Copiar detalles para soporte del cargo {{id, number}}",
      "col": {
        "period": "Periodo",
        "amount": "Importe",
        "mode": "Modo",
        "status": "Estado",
        "card": "Tarjeta",
        "attempt": "Intento",
        "lastError": "Último error",
        "actions": "Acciones"
      }
    },
    "catalogStatus": {
      "DRAFT": "Borrador",
      "ACTIVE": "Activo",
      "RETIRED": "Retirado"
    },
    "period": {
      "ANNUAL": "Anual",
      "MONTHLY": "Mensual"
    },
    "perPeriod": {
      "ANNUAL": "/ año",
      "MONTHLY": "/ mes"
    },
    "allowedBilling": {
      "CARD": "Tarjeta",
      "NET_FROM_PAYOUTS": "Descuento de pagos",
      "BOTH": "Tarjeta o descuento de pagos"
    },
    "billingMode": {
      "CARD": "Tarjeta",
      "NET_FROM_PAYOUTS": "Descuento de pagos"
    },
    "status": {
      "OFFERED": "Ofrecido",
      "ACTIVE": "Activo",
      "PAST_DUE": "Vencido",
      "LAPSED": "Caducado",
      "CANCELLED": "Cancelado",
      "DECLINED": "Rechazado",
      "WITHDRAWN": "Retirado"
    },
    "chargeStatus": {
      "PENDING": "Pendiente",
      "PAID": "Pagado",
      "FAILED": "Fallido",
      "ACTION_REQUIRED": "Acción requerida",
      "NETTING": "En descuento",
      "NETTED": "Descontado",
      "WAIVED": "Condonado",
      "REFUNDED": "Reembolsado"
    },
    "chargeMode": {
      "CARD": "Tarjeta",
      "NETTED": "Descontado"
    },
    "yes": "Sí",
    "no": "No",
    "actions": {
      "new": "Nuevo complemento…",
      "edit": "Editar…",
      "activate": "Activar",
      "retire": "Retirar",
      "reinstate": "Restablecer…",
      "cancel": "Cancelar",
      "save": "Guardar",
      "create": "Crear",
      "offer": "Ofrecer complemento…",
      "withdraw": "Retirar oferta",
      "cancelAddon": "Cancelar…",
      "waive": "Condonar…"
    },
    "form": {
      "createTitle": "Nuevo complemento",
      "editTitle": "Editar complemento",
      "kind": "Tipo",
      "kindHelp": "Una clave estable, p. ej. BRANDED_APP. No cambia una vez creada.",
      "kindInvalid": "Una letra y luego hasta 31 letras, dígitos o guiones bajos.",
      "name": "Nombre",
      "description": "Descripción",
      "period": "Periodo",
      "currency": "Moneda",
      "defaultPrice": "Precio predeterminado",
      "defaultPriceHelp": "Opcional.",
      "minorCaption": "Envía {{minor}} unidades menores",
      "allowedBilling": "Facturación permitida",
      "required": "Obligatorio.",
      "tooLong": "Como máximo {{max, number}} caracteres.",
      "nonNegative": "Debe ser cero o mayor."
    },
    "activate": {
      "title": "¿Activar {{name}}?",
      "confirm": "Entonces se podrá ofrecer a los tenants."
    },
    "reinstate": {
      "title": "¿Restablecer {{name}}?",
      "confirm": "Se podrá ofrecer de nuevo a los tenants.",
      "action": "Restablecer"
    },
    "retire": {
      "title": "¿Retirar {{name}}?",
      "confirm": "Ya no se podrá ofrecer. Los tenants que lo tienen lo conservan."
    },
    "activated": "{{name}} está activo.",
    "retired": "{{name}} está retirado.",
    "created": "{{name}} se añadió como borrador.",
    "updated": "{{name}} se guardó.",
    "saveError": "No se pudo guardar el complemento.",
    "actionError": "No se pudo actualizar el complemento.",
    "offer": {
      "title": "Ofrecer complemento",
      "addon": "Complemento",
      "chooseAddon": "Elige un complemento.",
      "noneActive": "No hay complementos activos en el catálogo.",
      "price": "Precio por periodo",
      "termStart": "Inicio de vigencia (opcional)",
      "autoRenew": "Renovación automática",
      "notes": "Notas (opcional)",
      "submit": "Ofrecer"
    },
    "withdraw": {
      "title": "¿Retirar la oferta?",
      "confirm": "¿Retirar la oferta de {{name}}? El tenant ya no podrá aceptarla."
    },
    "cancel": {
      "title": "¿Cancelar {{name}}?",
      "atTermEnd": "Al final de la vigencia",
      "termEndCaption": "El servicio continúa hasta el {{date}}.",
      "immediately": "De inmediato: el servicio se detiene ahora.",
      "reason": "Motivo (opcional)",
      "keep": "Conservar el complemento",
      "submit": "Cancelar complemento",
      "termEndCaptionUnknown": "El servicio continúa hasta el final del plazo actual."
    },
    "waive": {
      "title": "Condonar cargo",
      "reason": "Motivo",
      "reasonRequired": "El motivo es obligatorio.",
      "submit": "Condonar"
    },
    "merchantUnset": "El comerciante registrado no está configurado.",
    "openSettings": "Abrir Configuración"
  },
  "settings": {
    "nav": {
      "commerce": "Comercio",
      "operations": "Operaciones",
      "other": "Otros",
      "fees": "Comisiones de procesamiento",
      "standingCc": "CC de situación"
    },
    "maintenance": {
      "title": "Mantenimiento de facturación",
      "help": "Acciones puntuales para la configuración de facturación.",
      "backfill": {
        "action": "Registrar beneficiarios…",
        "title": "¿Registrar a los socios existentes como beneficiarios en pay-api?",
        "body": "Ejecútalo una sola vez, después de la adopción de pay-api. Queda auditado.",
        "confirm": "Registrar beneficiarios",
        "error": "No se pudo ejecutar el registro de beneficiarios.",
        "done": "Registro de beneficiarios terminado.",
        "matched": "Coincidentes {{value, number}}",
        "stored": "Guardados {{value, number}}",
        "kindFixed": "Tipo corregido {{value, number}}",
        "kindUnavailable": "Tipo aún no corregible {{value, number}}",
        "policySet": "Política aplicada {{value, number}}",
        "unmatched": "Sin coincidencia {{value, number}}",
        "failed": "Fallidos {{value, number}}",
        "failedIds": "No guardados: {{ids}}",
        "runAgain": "El tipo de algunos beneficiarios aún no se pudo corregir. Vuelve a ejecutarlo cuando pay-api lo tenga."
      }
    },
    "col": {
      "key": "Clave",
      "updated": "Actualizado",
      "value": "Valor"
    },
    "loadError": "No se pudo cargar la configuración del producto.",
    "merchant": {
      "change": "Cambiar…",
      "changeTitle": "Cambiar el comerciante registrado",
      "help": "El tenant cuya cuenta de pago cobra a los tenants por los complementos.",
      "saveError": "No se pudo guardar la configuración.",
      "tenantLabel": "Tenant",
      "title": "Comerciante registrado",
      "unset": "Sin configurar. Los cobros con tarjeta de complementos están en pausa hasta que se configure.",
      "concurrent": "Otra persona cambió esto al mismo tiempo. Inténtalo de nuevo."
    },
    "seller": {
      "title": "Vendedor y términos",
      "name": "Nombre del vendedor",
      "legalName": "Razón social",
      "version": "Versión de los términos",
      "termsUrl": "URL de los términos",
      "privacyUrl": "URL de la política de privacidad",
      "versionHint": "Letras, dígitos, punto, guion bajo o guion; hasta 32. Por ejemplo, 2026-10.",
      "urlHint": "Déjala vacía para no mostrar ninguna.",
      "nameRequired": "El nombre del vendedor es obligatorio.",
      "legalNameRequired": "La razón social es obligatoria.",
      "versionRequired": "La versión de los términos es obligatoria.",
      "versionInvalid": "Usa solo letras, dígitos, punto, guion bajo o guion; hasta 32.",
      "urlInvalid": "Escribe una dirección https de como máximo {{max, number}} caracteres, o déjala vacía.",
      "tooLong": "Como máximo {{max, number}} caracteres.",
      "saved": "Vendedor y términos guardados.",
      "unchanged": "No cambió nada, así que no se guardó nada.",
      "versionConfirm": {
        "title": "¿Cambiar la versión de los términos a {{termsVersion}}?",
        "body": "Los nuevos suscriptores deben aceptar la versión {{termsVersion}} antes de suscribirse. A los suscriptores actuales no se les obliga a volver a aceptarla; la app puede pedírselo. Sus suscripciones continúan.",
        "confirm": "Cambiar versión"
      }
    },
    "other": {
      "title": "Otras configuraciones",
      "empty": "No hay otra configuración."
    },
    "updatedAt": "Actualizado {{when}}",
    "standingCc": {
      "title": "CC de avisos de situación",
      "helper": "Direcciones de correo separadas por comas que reciben copia de cada aviso de situación",
      "invalid": "“{{entry}}” no es una dirección de correo.",
      "tooLong": "Como máximo {{max, number}} caracteres en total.",
      "save": "Guardar CC",
      "saved": "CC de avisos guardado."
    },
    "processing": {
      "title": "Comisiones de procesamiento de tarjeta",
      "help": "Lo que el procesador de tarjetas nos cobra por cada cobro, por moneda. El revendedor paga la parte de su margen. Un cambio se aplica desde ahora.",
      "col": {
        "currency": "Moneda",
        "percent": "Porcentaje",
        "fixed": "Fijo por cobro",
        "since": "Vigente desde"
      },
      "saved": "Comisión de procesamiento de tarjeta en {{currency}} guardada.",
      "invalid": "Revisa el porcentaje (0 a 100) y la comisión fija (0 o más).",
      "error": "No se pudo guardar la comisión de procesamiento de tarjeta.",
      "loadError": "No se pudo cargar la comisión en {{currency}}.",
      "percentLabel": "Porcentaje en {{currency}}",
      "fixedLabel": "Fijo por cobro en {{currency}}",
      "save": "Guardar",
      "none": "Sin definir: no se cuenta ninguna comisión de procesamiento en {{currency}}.",
      "next": "Siguiente: {{percent}} + {{fixed}} desde {{when}}",
      "edit": "Editar {{currency}}…"
    }
  },
  "resellerCards": {
    "col": {
      "actions": "Acciones"
    },
    "noncompliant": {
      "label": "No conforme",
      "since": "No conforme desde {{date}}"
    },
    "form": {
      "annualEmpty": "Déjalo vacío para ofrecer solo mensual."
    }
  },
  "customerRateCards": {
    "versionLabel": "v{{version, number}}",
    "noCurrent": "Sin versión publicada",
    "actions": {
      "editDetails": "Editar detalles…",
      "newVersion": "Nueva versión…",
      "publish": "Publicar…",
      "saveDraft": "Guardar borrador",
      "grant": "Conceder a un revendedor…",
      "revoke": "Revocar…",
      "move": "Mover suscriptores…",
      "adopt": "Adoptar…"
    },
    "status": {
      "DRAFT": "Borrador",
      "PUBLISHED": "Publicada",
      "RETIRED": "Retirada"
    },
    "chip": {
      "current": "Actual"
    },
    "tabs": {
      "versions": "Versiones",
      "grants": "Concesiones",
      "controls": "Controles"
    },
    "versions": {
      "tableAria": "Versiones",
      "version": "Versión",
      "state": "Estado",
      "published": "Publicada",
      "subscribers": "Suscriptores",
      "empty": "Aún no hay versiones.",
      "newError": "No se pudo añadir una versión."
    },
    "grants": {
      "reseller": "Revendedor",
      "adoption": "Adopción",
      "adopted": "Adopta este tarifario",
      "notAdopted": "Concedido",
      "empty": "Ningún revendedor tiene este tarifario.",
      "unpublished": "Los revendedores no pueden ver este tarifario hasta que se publique una versión."
    },
    "create": {
      "submit": "Crear tarifario",
      "nameRequired": "El nombre es obligatorio."
    },
    "publish": {
      "title": "Publicar la versión {{version, number}}",
      "consequence": "¿Publicar la versión {{version, number}}? Las ventas nuevas la usan. Los suscriptores actuales se quedan en su versión hasta que los muevas.",
      "confirm": "Publicar"
    },
    "move": {
      "title": "Mover suscriptores",
      "consequence": "¿Mover los suscriptores de este tarifario que están en versiones anteriores a la versión {{version, number}}? Cada uno que se mueva recibe un aviso.",
      "confirm": "Mover suscriptores",
      "result": "Movidos {{moved, number}}. Ya en esta versión: {{already, number}}. Fallidos: {{failed, number}}.",
      "failedWarning": "Algunos suscriptores no se movieron.",
      "error": "No se pudieron mover los suscriptores."
    },
    "grant": {
      "title": "Conceder a un revendedor",
      "reseller": "Revendedor",
      "confirm": "Conceder",
      "empty": "Todos los revendedores ya tienen este tarifario."
    },
    "revoke": {
      "title": "Revocar la concesión",
      "consequence": "¿Revocar esta concesión para {{reseller}}?",
      "confirm": "Revocar",
      "error": "No se pudo revocar esta concesión.",
      "adopted": "{{reseller}} usa este tarifario. Tiene que adoptar otro antes de que se pueda revocar esta concesión."
    },
    "adopt": {
      "title": "Adoptar tarifario",
      "confirm": "Adoptar",
      "consequence": "¿Adoptar {{name}} para este revendedor?",
      "notPublished": "Este tarifario no tiene una versión publicada.",
      "empty": "Ningún tarifario adoptado",
      "noneGranted": "No hay un tarifario concedido a este revendedor.",
      "error": "No se pudo adoptar este tarifario."
    },
    "errors": {
      "save": "No se pudo guardar esta versión.",
      "immutable": "Solo se puede editar una versión en borrador."
    },
    "form": {
      "aiFirstPurchase": "Primera compra de IA",
      "aiRechargeTrigger": "Recargar cuando el saldo baje de",
      "moreThanZero": "Debe ser mayor que cero.",
      "moreThanTrigger": "Debe ser mayor que el umbral de recarga.",
      "between0And100": "Debe estar entre 0 y 100."
    },
    "toast": {
      "published": "La versión {{version, number}} está publicada.",
      "granted": "Concedido a {{reseller}}.",
      "revoked": "Concesión revocada.",
      "versionAdded": "La versión {{version, number}} es un borrador nuevo.",
      "adopted": "{{name}} es el tarifario adoptado."
    }
  },
  "tenantRateCard": {
    "activateOrFix": "Primero activa o corrige el tarifario."
  },
  "resellerBilling": {
    "cardTitle": "Tarjeta registrada",
    "noCard": "No hay tarjeta registrada. El revendedor agrega una en su consola; hasta entonces no se pueden cobrar déficits ni faltantes.",
    "brand": "Marca",
    "number": "Número",
    "last4": "•••• {{last4}}",
    "expiry": "Vence",
    "expiryValue": "{{mm}}/{{yyyy}}",
    "status": "Estado",
    "cardReadOnly": "Solo lectura. El revendedor gestiona su tarjeta.",
    "cardStatus": {
      "ACTIVE": "Activa",
      "EXPIRED": "Tarjeta vencida",
      "requires_action": "Requiere la confirmación del revendedor"
    },
    "theCard": "la tarjeta registrada",
    "chargesTitle": "Cargos",
    "col": {
      "period": "Período",
      "kind": "Tipo",
      "amount": "Importe",
      "status": "Estado",
      "attempt": "Intento",
      "nextRetry": "Próximo reintento",
      "holdsPayouts": "Retiene pagos",
      "failure": "Fallo",
      "actions": "Acciones"
    },
    "noCharges": "No hay cargos.",
    "kind": {
      "MINIMUM_SHORTFALL": "Déficit del mínimo",
      "STATEMENT_DEFICIT": "Déficit del extracto"
    },
    "chargeStatus": {
      "PENDING": "Pendiente",
      "REQUESTED": "En proceso",
      "SUCCEEDED": "Cargo cobrado",
      "FAILED": "Fallido",
      "REQUIRES_ACTION": "Requiere acción"
    },
    "holdingPayouts": "Reteniendo pagos",
    "linkedCharge": "Cargo vinculado",
    "failure": {
      "NO_CARD": "No hay tarjeta registrada",
      "REVERIFY_CARD": "El banco pide confirmar la tarjeta; el revendedor debe agregarla de nuevo",
      "PSP_ERROR": "El proveedor de pagos tuvo un error",
      "FAILED": "Rechazado"
    },
    "retry": "Reintentar",
    "retryAria": "Reintentar el cargo de {{period}}",
    "confirm": {
      "title": "¿Reintentar el cobro de {{amount}} a la tarjeta registrada?",
      "body": "El cargo se envía ahora a {{card}}.",
      "noCard": "No hay tarjeta registrada, así que este intento fallará de inmediato."
    },
    "retried": "Cargo reintentado: {{status}}.",
    "loadError": "No se pudo cargar la facturación.",
    "errors": {
      "notRetryable": "Este cargo no se puede reintentar ahora.",
      "notFound": "No se encontró este cargo. Se recargó la lista.",
      "concurrent": "El cargo se estaba actualizando al mismo tiempo. Inténtalo de nuevo.",
      "retry": "No se pudo reintentar el cargo."
    },
    "retryFailed": "El reintento no se completó: {{failure}}",
    "noFailureReason": "Sin motivo de fallo"
  },
  "commissionPlans": {
    "title": "Planes de comisiones",
    "help": {
      "short": "Los revendedores diseñan sus propios planes de comisiones para afiliados; no hay planes de la plataforma.",
      "body": "Un afiliado conserva el plan asignado, y cada referido conserva de por vida el plan con el que se hizo. Los cambios aquí se hacen en nombre del revendedor y se auditan a tu nombre.",
      "schedule": "El mes 1 es el primer mes pagado del referido; las pruebas no cuentan.",
      "coolOff": "La comisión se retiene este tiempo tras cada pago y se anula si el pago se reembolsa en ese plazo. Más largo es más seguro; más corto es más atractivo.",
      "afterEnd": "Qué pasa con la comisión de los referidos existentes cuando termina el afiliado."
    },
    "actions": {
      "new": "Nuevo plan de comisiones",
      "edit": "Editar…",
      "fix": "Corregir este plan",
      "saveDraft": "Guardar borrador",
      "check": "Comprobar",
      "onThisPlan": "Afiliados con este plan"
    },
    "assigned": {
      "title": "Asignados a",
      "empty": "Ningún afiliado está en este plan.",
      "affiliate": "Afiliado",
      "tenant": "Tenant",
      "status": "Estado",
      "tableAria": "Afiliados asignados a {{name}}",
      "loadError": "No se pudieron cargar los afiliados."
    },
    "limits": "Límites de {{card}}: recurrente hasta {{pct}}, periodo de espera hasta {{days, number}} días.",
    "limitsError": "No se pudieron cargar los límites del tarifario adoptado.",
    "noAgreement": "Este revendedor necesita un acuerdo antes de poder tener planes de comisiones.",
    "openAgreement": "Abrir la pestaña Acuerdo",
    "empty": "Aún no hay planes de comisiones.",
    "tableAria": "Los planes de comisiones del revendedor",
    "loadError": "No se pudieron cargar los planes de comisiones de este revendedor.",
    "col": {
      "name": "Nombre",
      "mode": "Modo",
      "terms": "Condiciones",
      "appliesTo": "Se aplica a",
      "coolOff": "Periodo de espera",
      "afterEnd": "Tras el fin",
      "status": "Estado",
      "actions": "Acciones"
    },
    "collapse": "Contraer {{name}}",
    "expand": "Expandir {{name}}",
    "mode": {
      "SIMPLE": "Simple",
      "ADVANCED": "Avanzado"
    },
    "appliesTo": {
      "BASE": "Precio base",
      "ALL": "Todas las líneas"
    },
    "afterEnd": {
      "STOP": "Detener",
      "HONOR": "Respetar"
    },
    "terms": {
      "life": "{{rate}} de por vida",
      "oneMonth": "{{rate}} durante 1 mes",
      "months_one": "{{rate}} durante {{count, number}} mes",
      "months_other": "{{rate}} durante {{count, number}} meses",
      "phases_one": "{{count, number}} fase: {{rates}}",
      "phases_other": "{{count, number}} fases: {{rates}}",
      "bounty": "{{amount}} en el pago {{n, number}}",
      "milestones_one": "{{count, number}} hito",
      "milestones_other": "{{count, number}} hitos",
      "perReferralCap": "Por referido, como máximo {{amount}}",
      "perAffiliateMonthCap": "Por afiliado y mes, como máximo {{amount}}"
    },
    "noncompliant": {
      "explanation": "Supera un límite desde el {{date}}. No puede asignarse a más afiliados; los afiliados que lo tienen lo conservan."
    },
    "activate": {
      "confirm": "¿Activar {{name}}? Un plan activo no se puede editar; cópialo para cambiarlo.",
      "title": "¿Activar {{name}}?"
    },
    "close": {
      "confirm": "¿Cerrar {{name}}? No podrá darse a más afiliados; los afiliados que lo tienen lo conservan.",
      "title": "¿Cerrar {{name}}?"
    },
    "toast": {
      "created": "{{name}} es un nuevo borrador. Edítalo y luego actívalo.",
      "copied": "{{name}} es un nuevo borrador. Edítalo y luego actívalo.",
      "activated": "Plan activado. Ya puede darse a los afiliados.",
      "closed": "{{name}} está cerrado. Los afiliados que lo tienen lo conservan.",
      "saved": "{{name}} guardado. Actívalo cuando esté listo."
    },
    "errors": {
      "immutable": "Este plan ya no es un borrador. Cópialo para cambiarlo.",
      "nameTaken": "Otro plan de este revendedor se llama \"{{name}}\".",
      "overLimit": "Este plan supera un límite. Edítalo para corregirlo.",
      "create": "No se pudo crear el plan de comisiones.",
      "copy": "No se pudo copiar el plan de comisiones.",
      "activate": "No se pudo activar el plan de comisiones.",
      "close": "No se pudo cerrar el plan de comisiones.",
      "save": "No se pudo guardar el plan de comisiones."
    },
    "detail": {
      "phasesAria": "Fases de {{name}}",
      "currency": "Moneda",
      "created": "Creado",
      "activated": "Activado",
      "closed": "Cerrado",
      "noncompliantSince": "Supera un límite desde",
      "fromMonth": "Desde el mes",
      "toMonth": "Hasta el mes",
      "rate": "Tasa",
      "onward": "En adelante",
      "bounty": "Bono de captación",
      "onPayment": "en el pago {{n, number}}",
      "none": "Ninguno",
      "noCap": "Sin tope",
      "perReferralCap": "Por referido",
      "perAffiliateMonthCap": "Por afiliado y mes",
      "milestones": "Hitos",
      "milestonesAria": "Hitos de {{name}}",
      "qualifiedReferrals": "Referidos que califican",
      "bonus": "Bono"
    },
    "form": {
      "loadError": "No se pudo cargar este plan de comisiones.",
      "title": "Editar {{name}}",
      "loadingTitle": "Plan de comisiones",
      "notDraft": "Solo se puede editar un plan en borrador. Cópialo para hacer cambios.",
      "rate": "Tasa (%)",
      "months": "Número de meses",
      "schedule": "Calendario",
      "phaseRate": "Tasa de la fase {{n, number}} (%)",
      "phaseTo": "Fase {{n, number}} hasta el mes",
      "phaseFrom": "Fase {{n, number}} desde el mes",
      "name": "Nombre",
      "mode": "Modo",
      "appliesTo": "Se aplica a",
      "coolOff": "Periodo de espera (días)",
      "afterEnd": "Cuando termina el afiliado",
      "rateRange": "Introduce una tasa de 0 a 100.",
      "nameRequired": "El nombre es obligatorio.",
      "nameLong": "Usa como máximo {{max, number}} caracteres.",
      "monthsRange": "Introduce un número entero de meses, 1 o más.",
      "onlyLastOpen": "Solo la última fase puede ser en adelante.",
      "toRange": "Introduce un mes a partir del {{from, number}}.",
      "coolOffRange": "Introduce un número entero de 0 a {{max, number}}.",
      "fixedFrom": "Copiado de {{name}}. Ponlo dentro de los límites, actívalo y luego pasa los afiliados a él.",
      "warnMargin": "Una tasa recurrente nunca paga más que el margen del revendedor en esa línea. Con precio a nuestro mayorista, la comisión recurrente es 0.",
      "warnAnnual": "Las suscripciones anuales se comisionan según la fase de la fecha de pago, sobre el importe anual completo.",
      "section": {
        "plan": "Plan",
        "terms": "Condiciones",
        "advanced": "Bono de captación, hitos y topes"
      },
      "simpleBlocked": "Quita primero las fases de más",
      "simpleBlockedEconomics": "Quita primero el bono de captación, los hitos y los topes",
      "leaveEmpty": "Déjalo vacío para ninguno",
      "appliesToBase": "Solo el precio de la suscripción.",
      "appliesToAll": "Base, puestos, cuentas conectadas e IA (nunca impuestos).",
      "afterEndStop": "No se gana nada más después de la fecha de fin del afiliado.",
      "afterEndHonor": "Los referidos existentes siguen generando.",
      "duration": "Duración",
      "forMonths": "Durante un número de meses",
      "forLife": "De por vida",
      "phases": "Fases",
      "rowActions": "Quitar",
      "removePhase": "Quitar la fase {{n, number}}",
      "addPhase": "Añadir fase",
      "bounty": "Bono de captación",
      "bountyOnPayment": "Pagado en el pago n.º del referido",
      "bountyHelp": "Un importe único, pagado cuando el referido hace esa cantidad de pagos base, después del periodo de espera. Se anula si un pago se reembolsa antes.",
      "bountyOnPaymentRange": "Introduce un número entero de 1 a {{max, number}}.",
      "milestones": "Hitos",
      "milestonesHelp": "Se paga una vez cada uno cuando el número de referidos que califican del afiliado (pagados, superado el periodo de espera, aún suscritos) alcanza la cifra por primera vez, al cierre de mes del revendedor.",
      "milestoneQualified": "Referidos que califican del hito {{n, number}}",
      "milestoneBonus": "Bono por meta {{n, number}}",
      "qualifiedRange": "Introduce un número entero, 1 o más.",
      "amountInvalid": "Introduce un importe.",
      "addMilestone": "Añadir hito",
      "removeMilestone": "Quitar el hito {{n, number}}",
      "perReferralCap": "Por referido, como máximo",
      "perReferralCapHelp": "Lo máximo que un referido puede hacer ganar al afiliado.",
      "perAffiliateMonthCap": "Por afiliado y mes, como máximo",
      "perAffiliateMonthCapHelp": "Lo máximo que un afiliado puede ganar de ti en un mes.",
      "noCap": "Sin tope",
      "upTo": "Hasta {{amount}}.",
      "eachUpTo": "Cada uno hasta {{amount}}.",
      "warnNotLimited": "Los bonos de captación y los hitos no están limitados por el margen. Se cargan en la liquidación mensual del revendedor, y un mes negativo se carga a la tarjeta del revendedor."
    },
    "preview": {
      "title": "Comprobar con los límites",
      "cardsError": "No se pudieron cargar los tarifarios.",
      "card": "Tarifario para el ejemplo",
      "error": "No se pudo comprobar el plan.",
      "noCard": "Añade un tarifario para este revendedor para ver un ejemplo.",
      "loadingCards": "Cargando tarifarios…",
      "fixFields": "Corrige los campos resaltados para comprobar este plan.",
      "checking": "Comprobando…",
      "empty": "Cambia un campo o elige Comprobar para ver si el plan está dentro de los límites y cuánto paga.",
      "valid": "Este plan está dentro de los límites.",
      "invalid": "Este plan incumple un límite o una regla del calendario. Cada campo que lo hace dice por qué.",
      "noExample": "Corrige el calendario para ver un ejemplo.",
      "exampleAria": "Ejemplo por mes",
      "exampleTitle": "Un suscriptor a {{amount}} al mes con {{card}}",
      "exampleCaption": "Meses pagados 1–24, el primero cobrado hoy. Pagadero tras un periodo de espera de {{days, number}} días.",
      "col": {
        "month": "Mes",
        "collected": "Cobrado",
        "rate": "Tasa",
        "commission": "Comisión",
        "marginBefore": "Margen del revendedor antes",
        "marginAfter": "Margen del revendedor después",
        "payableOn": "Pagadero el",
        "bounty": "Bono de captación",
        "capped": "Con tope"
      },
      "capped": "Con tope"
    }
  },
  "affiliates": {
    "tabs": {
      "aria": "Secciones del afiliado"
    },
    "absent": "—",
    "filter": {
      "all": "Todos"
    },
    "list": {
      "title": "Afiliados",
      "help": "Los afiliados pertenecen a este tenant y los gestiona su revendedor. Puedes verlos, y pausar o terminar uno por causa.",
      "aria": "Afiliados",
      "empty": "Aún no hay afiliados.",
      "filteredEmpty": "Ningún afiliado coincide con este filtro.",
      "loadError": "No se pudieron cargar los afiliados.",
      "filterAria": "Estado del afiliado"
    },
    "col": {
      "name": "Nombre",
      "email": "Correo",
      "status": "Estado",
      "plan": "Plan",
      "referredActive": "Referidos activos",
      "last30": "Últimos 30 días",
      "subscriber": "Suscriptor",
      "offer": "Oferta",
      "since": "Desde",
      "firstPaid": "Primer pago",
      "thisPeriod": "Este período",
      "code": "Código",
      "label": "Etiqueta",
      "link": "Enlace",
      "week": "Semana",
      "signups": "Altas",
      "currency": "Moneda",
      "revenue30": "Ingresos referidos, 30 días",
      "revenueToDate": "Ingresos referidos, hasta la fecha",
      "commission30": "Comisión, 30 días",
      "commissionToDate": "Comisión, hasta la fecha",
      "effective": "Vigente",
      "ended": "Terminado",
      "cadence": "Cadencia",
      "minimum": "Pago mínimo",
      "method": "Método",
      "taxDocs": "Documentos fiscales"
    },
    "status": {
      "APPLIED": "Solicitado",
      "ACTIVE": "Activo",
      "PAUSED": "En pausa",
      "ENDED": "Terminado"
    },
    "referralStatus": {
      "ACTIVE": "Activo",
      "ENDED": "Terminado",
      "SUPERSEDED": "Sustituido",
      "VOIDED": "Anulado"
    },
    "codeStatus": {
      "ACTIVE": "Activo",
      "PAUSED": "En pausa"
    },
    "plan": {
      "noAgreement": "Sin acuerdo",
      "fallback": "Plan n.º {{id}}",
      "noncompliant": "Supera un límite. No puede asignarse a más afiliados; los afiliados que lo tienen lo conservan."
    },
    "last30": {
      "revenue": "de ingresos",
      "commission": "de comisión"
    },
    "held": {
      "chip": "Retenido para revisión"
    },
    "page": {
      "notFound": "Afiliado no encontrado",
      "loadError": "No se pudo cargar este afiliado.",
      "copyId": "Copiar ID {{id}}"
    },
    "dates": {
      "applied": "Solicitado el {{date}}",
      "approved": "Aprobado el {{date}}",
      "ended": "Terminado el {{date}}",
      "effective": "Vigente el {{date}}",
      "endedOn": "Terminado el {{date}}"
    },
    "stateChanged": "El estado de este afiliado cambió",
    "pause": {
      "action": "Pausar",
      "title": "¿Pausar a {{name}}?",
      "words": "Los referidos nuevos dejan de atribuirse; los existentes siguen generando.",
      "confirm": "Pausar",
      "failed": "No se pudo pausar este afiliado."
    },
    "resume": {
      "action": "Reanudar",
      "title": "¿Reanudar a {{name}}?",
      "words": "Los referidos nuevos pueden atribuirse de nuevo.",
      "confirm": "Reanudar",
      "failed": "No se pudo reanudar este afiliado."
    },
    "end": {
      "action": "Terminar por causa…",
      "title": "Terminar a {{name}} por causa",
      "words": "Terminar aquí detiene toda ganancia y retiene la comisión impaga para revisión. No se puede deshacer.",
      "confirm": "Terminar por causa",
      "failed": "No se pudo terminar este afiliado."
    },
    "release": {
      "action": "Liberar la retención…",
      "title": "Liberar la retención",
      "words": "¿Liberar la comisión impaga de {{name}} para el pago?",
      "confirm": "Liberar la retención",
      "row": "Liberar la retención de {{name}}",
      "done": "Retención liberada. Los extractos impagos pueden pagarse.",
      "failed": "No se pudo liberar la retención."
    },
    "reason": {
      "label": "Motivo",
      "length": "Usa de 3 a 500 caracteres."
    },
    "hold": {
      "alert": "Pagos retenidos para revisión desde el {{date}}: {{reason}} (por {{by}})"
    },
    "performance": {
      "title": "Rendimiento",
      "aria": "Ingresos referidos y comisión por moneda",
      "empty": "Aún no hay ingresos referidos.",
      "summary_one": "{{active, number}} de {{count, number}} suscriptor referido",
      "summary_other": "{{active, number}} de {{count, number}} suscriptores referidos"
    },
    "earnings": {
      "title": "Ganancias",
      "aria": "Ganancias por mes en {{currency}}",
      "empty": "Aún no hay ganancias.",
      "loadError": "No se pudieron cargar las ganancias.",
      "col": {
        "month": "Mes",
        "recurring": "Recurrente",
        "bounty": "Bono de captación",
        "milestone": "Hito",
        "pending": "Pendiente",
        "payable": "Pagadero",
        "voided": "Anulado",
        "clawedBack": "Revertido",
        "recovered": "Recuperado"
      }
    },
    "signups": {
      "title": "Altas semanales",
      "aria": "Altas semanales",
      "empty": "Aún no hay altas semanales."
    },
    "agreement": {
      "title": "Acuerdo",
      "none": "Sin acuerdo",
      "history": "Historial",
      "historyAria": "Historial del acuerdo",
      "loadError": "No se pudo cargar el acuerdo.",
      "inForceAria": "Acuerdo vigente"
    },
    "referrals": {
      "title": "Referidos",
      "aria": "Referidos",
      "empty": "Aún no hay referidos.",
      "filteredEmpty": "Ningún referido coincide con este filtro.",
      "loadError": "No se pudieron cargar los referidos.",
      "filterAria": "Estado del referido",
      "notYetPaid": "Aún no pagado"
    },
    "codes": {
      "title": "Códigos",
      "aria": "Códigos",
      "empty": "Aún no hay códigos.",
      "loadError": "No se pudieron cargar los códigos.",
      "copy": "Copiar el enlace de {{code}}"
    }
  },
  "partners": {
    "singular": "Socio",
    "new": "Nuevo socio…",
    "subtitle": "Los socios y sus negocios, juntos en un solo lugar.",
    "search": "Buscar socios",
    "searchPlaceholder": "Buscar socio o slug",
    "searchHint": "Busca en el nombre y slug del socio",
    "empty": "Aún no hay socios.",
    "emptySearch": "Ningún socio coincide con la búsqueda.",
    "noTenant": "Aún no hay tenant",
    "canSell": "Puede vender",
    "createTenant": "Crear tenant…",
    "createTenantSuspended": "Este socio está suspendido. Reactívalo antes de crear su tenant.",
    "createTenantDeactivated": "Este socio está desactivado.",
    "createTenantHasTenant": "Este socio ya tiene un tenant.",
    "notFound": "Socio no encontrado",
    "loadingTitle": "Socio",
    "resolveError": "No se pudo encontrar este socio.",
    "tenantIdentity": "Tenant: {{name}} ({{slug}})",
    "perMonth": "al mes",
    "step1": "Paso 1 de 2 — Crear socio",
    "step2": "Paso 2 de 2 — Crear tenant",
    "tenantFailed": "Socio creado. No se pudo confirmar la creación del tenant. Revisa la página del socio antes de volver a intentarlo.",
    "paletteFailed": "No se pudieron buscar socios — reintentar",
    "searchList": "Buscar en la lista de socios",
    "scopeAll": "Todos los socios",
    "scope": "Socio: {{name}}",
    "number": "Socio #{{id}}",
    "sectionsAria": "Secciones del socio",
    "partnerAdministrators": {
      "caption": "Inicia sesión en la consola del revendedor para administrar este socio."
    },
    "tenantAdministrators": {
      "caption": "Inicia sesión en la aplicación del tenant para gestionar el negocio."
    },
    "section": {
      "overview": "Resumen",
      "reports": "Informes",
      "settings": "Ajustes"
    },
    "caption": {
      "overview": "¿Qué te necesita y cómo va este socio?",
      "reports": "Qué está pasando, a lo largo del tiempo.",
      "settings": "Cómo está configurado este socio."
    },
    "tab": {
      "overview": "Resumen",
      "agreement": "Acuerdo",
      "standing": "Situación",
      "billing": "Cargos",
      "settlements": "Liquidaciones",
      "priceCard": "Tarifario",
      "offers": "Ofertas",
      "promotions": "Promociones",
      "addons": "Complementos",
      "subscriptions": "Suscripciones",
      "statements": "Extractos",
      "seats": "Plazas",
      "aiUsage": "Uso de IA",
      "revenue": "Ingresos",
      "deletions": "Eliminaciones",
      "affiliates": "Afiliados",
      "commissionPlans": "Planes de comisiones",
      "affiliatePayouts": "Pagos a afiliados",
      "partnerAdministrators": "Administradores del socio",
      "tenantAdministrators": "Administradores del tenant",
      "customers": "Clientes",
      "domain": "Dominio",
      "ghl": "Conexión GHL",
      "payments": "Cobros",
      "details": "Detalles y marca",
      "cardOnFile": "Tarjeta registrada",
      "ledger": "Saldo y retenciones",
      "notices": "Avisos enviados",
      "ledgerStatements": "Extractos",
      "ledgerUnassigned": "Líneas sin asignar"
    },
    "sellableReason": {
      "NO_RESELLER": "Sin revendedor",
      "NO_AGREEMENT": "Sin acuerdo",
      "NO_RATE_CARD": "Sin tarifario",
      "CURRENCY_NOT_PRICED": "Moneda sin precio"
    },
    "searching": "Buscando socios",
    "platformManaged": {
      "chip": "Gestionado por la plataforma",
      "alert": "Gestionado por la plataforma desde {{date}}. Las liquidaciones se retienen; reactívalo para reanudar los pagos."
    },
    "house": {
      "chip": "Propio",
      "mark": "Marcar como socio propio…",
      "unmark": "Desmarcar como socio propio…",
      "markTitle": "¿Marcar a {{partner}} como socio propio?",
      "unmarkTitle": "¿Quitar a {{partner}} como socio propio?",
      "consequence": "El socio propio es nuestro: nunca se evalúa ni se desactiva.",
      "error": "No se pudo cambiar la marca de socio propio.",
      "standingConflict": "Un socio en proceso de desactivación no puede marcarse como propio. Reactívalo primero."
    },
    "creationWarning": {
      "openPayments": "Abrir Cobros"
    },
    "group": {
      "standing": "Situación",
      "money": "Dinero",
      "subscribers": "Suscriptores",
      "affiliates": "Afiliados",
      "terms": "Condiciones",
      "pricing": "Precios",
      "profile": "Perfil",
      "access": "Acceso",
      "connections": "Conexiones"
    },
    "needsYou": {
      "title": "Te necesita",
      "caption": "Lo que bloquea ahora a este socio. Cada uno abre donde se soluciona.",
      "empty": "Nada te necesita ahora mismo.",
      "checking": "Comprobando qué te necesita…",
      "count_one": ", {{count, number}} te necesita",
      "count_other": ", {{count, number}} te necesitan",
      "dot": " — te necesita",
      "openAgreement": "Abrir acuerdo",
      "openCharges": "Abrir cargos",
      "launch": {
        "title": "Lanzamiento oficial sin definir",
        "body": "Ningún mes se compara con el mínimo hasta que se defina un mes de lanzamiento."
      },
      "charges": {
        "title_one": "{{count, number}} cargo se puede reintentar",
        "title_other": "{{count, number}} cargos se pueden reintentar",
        "body": "Falló un cargo a la tarjeta de este socio. Puedes intentarlo de nuevo.",
        "loadError": "No se pudieron comprobar los cargos de este socio."
      }
    },
    "atAGlance": {
      "title": "De un vistazo",
      "caption": "Solo lectura. Abre una tarjeta para ver su informe."
    }
  },
  "aiReconciliation": {
    "from": "Desde (UTC)",
    "to": "Hasta (UTC)",
    "range": {
      "order": "El inicio debe ser igual o anterior al final.",
      "tooLong": "Elige como máximo 366 días.",
      "refused": "No se pueden mostrar estas fechas. Elige como máximo 366 días, con el inicio igual o anterior al final."
    },
    "loadError": "No se pudo cargar la conciliación de costos de IA.",
    "empty": "No hay filas de conciliación para estos días.",
    "regionAria": "Tabla de conciliación de costos de IA",
    "tableAria": "Conciliación de costos de IA",
    "mustBeZero": "debe ser 0",
    "shouldBeZero": "debería ser 0",
    "legend": "† Debe ser 0.",
    "breached": "Incumplido",
    "col": {
      "day": "Día",
      "currency": "Moneda",
      "sent": "Enviadas",
      "settledActual": "Liquidadas según el uso",
      "settledAtHold": "Liquidadas por la reserva",
      "holdExpiredCharged": "Reserva vencida, cobrada",
      "providerRejected": "Rechazadas por el proveedor",
      "providerRejectedAuth": "Rechazadas: autenticación",
      "releasedAfterSend": "Liberadas tras el envío",
      "costOverHold": "Costo superior a la reserva",
      "sentUnsettled": "Enviadas, sin liquidar",
      "providerCost": "Costo del proveedor",
      "customerUsage": "Uso del cliente",
      "platformCost": "Costo pagado por la plataforma",
      "reconciledAt": "Conciliado el",
      "truncated": "Truncadas",
      "refused": "Rechazadas"
    },
    "help": {
      "truncated": "Respuestas cortadas en el límite de tokens. Se cobran según su uso.",
      "refused": "Solicitudes que el modelo rechazó."
    }
  },
  "cardSettings": {
    "controls": {
      "title": "Controles",
      "maxAiSpend": "Gasto máximo de IA por persona al mes",
      "maxAiSpendHelp": "Lo máximo que una persona puede gastar en IA en un mes. El límite propio más bajo de la persona sigue aplicándose.",
      "aiDailyCap": "Límite diario de IA",
      "aiDailyCapHelp": "El máximo de llamadas de IA que una persona puede hacer en un día.",
      "aiMaxInflight": "Llamadas de IA simultáneas",
      "aiMaxInflightHelp": "Cuántas llamadas de IA puede tener una persona en curso al mismo tiempo.",
      "autoRecharges": "Recargas automáticas cada 30 días",
      "autoRechargesHelp": "0 significa que el monedero nunca se recarga solo; la persona recarga a mano.",
      "graceDays": "Días de gracia tras el fin de una suscripción",
      "graceDaysHelp": "Se lee cuando empieza la gracia. Una suscripción que ya está en gracia conserva su fecha de fin.",
      "reviewSuggested": "Este tarifario no está en USD y aún tiene el gasto máximo de IA inicial. Revísalo y programa el importe correcto.",
      "affiliateRecurringMax": "Comisión recurrente máxima de afiliados",
      "affiliateRecurringMaxHelp": "La tasa más alta en cualquier fase de un plan de comisiones del revendedor. Se comprueba al crear o activar un plan; los planes activos no cambian.",
      "affiliateBountyMax": "Bono de captación máximo",
      "affiliateBountyMaxHelp": "El bono de captación más alto que un plan de comisiones puede ofrecer por referido.",
      "affiliateMilestoneMax": "Bono por hito máximo",
      "affiliateMilestoneMaxHelp": "El bono por hito más alto que un plan de comisiones puede ofrecer.",
      "affiliateCoolOffMax": "Periodo de espera máximo de afiliados",
      "affiliateCoolOffMaxHelp": "El periodo de espera más largo, en días, que un plan de comisiones puede fijar."
    }
  },
  "platformAiControls": {
    "title": "Controles de IA de la plataforma",
    "help": "La IA del asistente de dominios la paga la plataforma. Estos límites la acotan.",
    "resellerDaily": "Llamadas de IA de configuración de dominio por revendedor al día",
    "platformDaily": "Llamadas de IA de configuración de dominio en toda la plataforma al día"
  },
  "datedSettings": {
    "current": "Actual",
    "inEffectSince": "Vigente desde {{when}}",
    "setBy": "Definido por {{who}}",
    "noteLine": "Nota: {{note}}",
    "scheduled": "Programados",
    "noneScheduled": "No hay cambios programados.",
    "scheduledAria": "{{title}}: cambios programados",
    "history": "Historial",
    "noHistory": "No hay configuraciones anteriores.",
    "historyAria": "{{title}}: historial",
    "withdraw": "Retirar…",
    "withdrawRow": "Retirar el cambio que empieza el {{when}}",
    "withdrawn": "Retirado",
    "withdrawnBy": "por {{who}}",
    "past": "Pasado",
    "schedule": "Programar un cambio…",
    "scheduleTitle": "Programar un cambio: {{title}}",
    "withdrawTitle": "Retirar un cambio programado",
    "withdrawConsequence": "¿Retirar el cambio que empieza el {{when}}?",
    "withdrawConfirm": "Retirar",
    "form": {
      "required": "Obligatorio.",
      "tooLong": "Usa como máximo {{max, number}} caracteres.",
      "between": "Debe estar entre {{min, number}} y {{max, number}}.",
      "atLeast": "Debe ser al menos {{min, number}}.",
      "atMost": "Debe ser como máximo {{max, number}}.",
      "number": "Escribe un número.",
      "whole": "Debe ser un número entero.",
      "whenRequired": "Elige una fecha y una hora.",
      "when": "Cuándo",
      "now": "Ahora",
      "at": "Desde una fecha y hora",
      "date": "Fecha (UTC)",
      "time": "Hora (UTC)",
      "note": "Nota (opcional)",
      "submit": "Programar"
    },
    "errors": {
      "taken": "Ya hay otro cambio que empieza a esa hora. Elige otra hora.",
      "future": "Debe ser en el futuro. Elige Ahora para aplicarlo enseguida.",
      "notLater": "Elige una hora posterior a ahora (UTC), o elige Ahora.",
      "schedule": "No se pudo programar este cambio.",
      "notFound": "No se encontró esa configuración.",
      "inEffect": "Este cambio ya está vigente, así que no se puede retirar. Se ha recargado la lista.",
      "rowInForce": "Esta configuración ya está en vigor y no se puede retirar. Programa un valor nuevo en su lugar.",
      "lastRow": "Esta es la única fila de la configuración, así que no se puede retirar.",
      "withdraw": "No se pudo retirar este cambio."
    },
    "loadError": "No se pudo cargar esta configuración.",
    "col": {
      "starts": "Empieza",
      "setBy": "Definido por",
      "note": "Nota",
      "actions": "Acciones",
      "status": "Estado"
    }
  },
  "rateCard": {
    "prices": {
      "readOnly": "Una versión publicada es de solo lectura. Usa Nueva versión… para cambiar sus precios.",
      "editTitle": "Precios de la versión {{version, number}}",
      "ourCost": "Nuestro costo",
      "wholesale": "Mayorista",
      "retail": "Minorista",
      "annualWholesale": "Mayorista por año",
      "annualRetail": "Minorista por año",
      "guestsIncluded": "Invitados incluidos",
      "perGuestCost": "Nuestro costo por invitado",
      "perGuestWholesale": "Mayorista por invitado",
      "perGuestRetail": "Minorista por invitado",
      "connectionsIncluded": "Conexiones bancarias incluidas",
      "perConnectionCost": "Nuestro costo por conexión",
      "perConnectionWholesale": "Mayorista por conexión",
      "perConnectionRetail": "Minorista por conexión",
      "aiWholesaleMarkup": "Margen mayorista sobre el costo del proveedor (%)",
      "aiRetailMarkup": "Margen minorista sobre el mayorista (%)",
      "creditAtCost": "Crédito mensual de IA, a nuestro costo",
      "creditAtRetail": "Crédito mensual de IA, al precio del cliente",
      "creditShare": "Parte del crédito que asumimos (%)",
      "rechargeAmount": "Monto de recarga del monedero",
      "help": {
        "ourCost": "Lo que nos cuesta un suscriptor cada mes. Solo lo ve el administrador del producto; se permite una pérdida y aparece en la hoja de cálculo.",
        "wholesale": "Lo que el revendedor nos paga cada mes por un suscriptor.",
        "retail": "Lo que el cliente paga cada mes.",
        "annualWholesale": "Lo que el revendedor nos paga por un plan anual.",
        "annualRetail": "Lo que el cliente paga por un año. Déjalo vacío para ofrecer solo el plan mensual.",
        "included": "Cuántos son gratis para el cliente y para el revendedor. Nosotros asumimos su costo.",
        "unitCost": "Lo que nos cuesta cada uno, incluido o no.",
        "unitWholesale": "Lo que el revendedor nos paga por cada uno después de los incluidos.",
        "unitRetail": "Lo que el cliente paga por cada uno después de los incluidos.",
        "aiWholesaleMarkup": "Nuestro margen sobre el costo del proveedor de IA: el precio de IA del revendedor.",
        "aiRetailMarkup": "El margen sobre el precio mayorista de IA: el precio de IA del cliente.",
        "credit": "La IA que el cliente recibe cada mes. Fíjala al precio del cliente o por lo que nos cuesta; convertimos nuestro costo con los márgenes y guardamos el precio del cliente.",
        "creditShare": "Cuánto del crédito asumimos. El revendedor asume el resto."
      },
      "tiered": "Esta versión tiene bandas escalonadas. Se muestran como solo lectura y al guardar se mantienen igual.",
      "section": {
        "base": "Base, por mes",
        "annual": "Base, por año",
        "guests": "Invitados",
        "connections": "Conexiones bancarias"
      },
      "annualCostNote": "Nuestro costo anual es el costo mensual × 12; la hoja de cálculo lo usa.",
      "creditBy": "Fija el crédito mensual por",
      "creditByRetail": "Precio del cliente",
      "creditByCost": "Nuestro costo",
      "creditCostCaption": "Convertimos nuestro costo con los márgenes de arriba. Guardado ahora: {{amount}} al precio del cliente.",
      "creditRetailCaption": "El crédito al precio del cliente.",
      "bandsAria": "Bandas",
      "bandFrom": "Desde",
      "bandTo": "Hasta",
      "bandRetail": "Minorista fijo + por unidad",
      "bandWholesale": "Mayorista fijo + por unidad",
      "bandCost": "Nuestro costo fijo + por unidad",
      "bandOpen": "en adelante",
      "summaryAria": "Precios",
      "line": "Línea",
      "aiSummary": "IA: margen mayorista de {{wholesale}} sobre el costo del proveedor, margen minorista de {{retail}} sobre el mayorista. Crédito mensual de {{credit}} al precio del cliente; asumimos {{share}}.",
      "rule": {
        "notNegative": "Debe ser cero o más.",
        "checkBand": "Revisa los precios de esta banda.",
        "wholesale": "Debe ser mayor que cero y no superar el precio minorista.",
        "aboveZero": "Debe ser mayor que cero."
      }
    },
    "grid": {
      "perGuestOver": "Por invitado sobre {{n, number}}",
      "perConnectionOver": "Por conexión sobre {{n, number}}",
      "monthly": "Mensual",
      "annual": "Anual"
    },
    "singular": "Tarifario",
    "notFound": "No se encontró ese tarifario.",
    "loadError": "No se pudo cargar este tarifario.",
    "draftOnly": "borrador",
    "actions": {
      "publishVersion": "Publicar la versión {{version, number}}…",
      "worksheet": "Hoja de cálculo",
      "editPrices": "Editar precios…"
    },
    "tabs": {
      "aria": "Secciones del tarifario",
      "worksheet": "Hoja de cálculo",
      "prices": "Precios",
      "resellers": "Revendedores"
    },
    "versionPicker": "Versión",
    "publishRefused": "La versión {{version, number}} aún no se puede publicar. Corrige los precios marcados, guarda el borrador y luego publícala.",
    "publishRefusedOther": "Algunas de las comprobaciones que fallaron no tienen campo en esta página.",
    "toast": {
      "saved": "Precios guardados."
    },
    "grant": {
      "error": "No se pudo conceder este tarifario."
    },
    "resellers": {
      "adoptHint": "Un revendedor adopta un tarifario concedido en su página de socio."
    },
    "list": {
      "subtitle": "Cada tarifario tiene nuestro costo, el mayorista y el minorista. Concédelo a revendedores; cada revendedor adopta uno.",
      "filterAria": "Estado del tarifario",
      "filter": {
        "active": "Activos",
        "drafts": "Borradores",
        "all": "Todos"
      },
      "search": "Buscar por nombre",
      "loadError": "No se pudieron cargar los tarifarios.",
      "filteredEmpty": "Ningún tarifario coincide. Prueba con Todos u otro nombre.",
      "add": "Añadir tarifario",
      "cardLink": "{{name}}, {{currency}} · {{versionLabel}}",
      "notGranted": "Aún no concedido",
      "resellers": "{{granted, number}} concedidos, {{adopted, number}} adoptados",
      "pillAdopted": "{{name}} (adoptado)",
      "pillGranted": "{{name}}"
    },
    "create": {
      "nameClash": "Otro tarifario tiene este nombre.",
      "error": "No se pudo crear el tarifario.",
      "hint": "El primer borrador se abre en Precios, donde fijas nuestro costo, el mayorista y el minorista.",
      "setControls": "Fijar los controles ahora",
      "controlsOn": "Con los valores estándar ya puestos. Un campo que dejes vacío toma el valor estándar.",
      "controlsOff": "El tarifario empieza con los controles estándar. Puedes programar un cambio en su pestaña Controles."
    },
    "worksheet": {
      "subscriber": "Un suscriptor hipotético",
      "mode": "Modo de facturación",
      "monthly": "Mensual",
      "annual": "Anual",
      "noAnnual": "Esta versión no tiene precio anual.",
      "guests": "Invitados",
      "countRange": "Un número entero de 0 a 50.",
      "connections": "Cuentas bancarias conectadas",
      "aiUsed": "IA usada por mes (precio del cliente)",
      "updating": "Actualizando la hoja de cálculo",
      "loadError": "No se pudo calcular esta hoja de cálculo.",
      "fixInputs": "Corrige los datos para ver la hoja de cálculo.",
      "billYearly": "La factura del cliente (facturada anualmente)",
      "billMonthly": "La factura del cliente (facturada mensualmente)",
      "billAria": "La factura del cliente",
      "col": {
        "line": "Línea",
        "quantity": "Cant.",
        "amount": "Importe",
        "unitPrice": "Precio unitario"
      },
      "line": {
        "BASE": "Base",
        "GUESTS": "Invitados",
        "CONNECTIONS": "Conexiones bancarias",
        "SUBSCRIPTION_PROCESSING": "Procesamiento de tarjeta de la suscripción",
        "AI_PAID": "IA que paga el cliente",
        "AI_CREDIT": "IA cubierta por el crédito",
        "RECHARGE_PROCESSING": "Procesamiento de tarjeta de las recargas",
        "TOTAL": "Total"
      },
      "charge": {
        "BASE": "Plan base",
        "ADD_ONS": "Invitados y conexiones",
        "RECHARGE": "Recarga del monedero"
      },
      "steps": "Cómo se calcula",
      "chargesPerYear": "Cobros de suscripción al año: {{n, number}}.",
      "chargeLine": "{{kind}}: {{gross}} cobrados {{perYear, number}} veces al año. Comisión de tarjeta {{fee}}: el revendedor paga {{reseller}}, nosotros pagamos {{platform}}.",
      "noRate": "No hay comisión de procesamiento de tarjeta para {{currency}}, así que no se cuenta ninguna.",
      "rate": "Procesamiento de tarjeta: {{percent}} + {{fixed}} por cobro.",
      "recharges": "Recargas automáticas del monedero al mes: {{n, number}}.",
      "creditCost": "El crédito mensual de IA nos cuesta {{amount}}.",
      "customerPays": "Paga el cliente",
      "resellerProfit": "Ganancia del revendedor",
      "ourProfit": "Nuestra ganancia",
      "profitPercent": "{{percent}} de lo que paga el cliente",
      "earningsAnnual": "Quién gana qué, por mes (el plan anual ÷ 12)",
      "earnings": "Quién gana qué, por mes",
      "earningsAria": "Quién gana qué, por línea",
      "resellerCosts": "Costos del revendedor",
      "ourCost": "Nuestro costo",
      "note": "Ganancia del revendedor = paga el cliente + costos del revendedor. Nuestra ganancia = el mayorista que nos paga el revendedor + nuestro costo. La comisión de afiliados sale de la ganancia del revendedor.",
      "bill": {
        "BASE": "Suscripción base",
        "BASE_YEAR": "Suscripción base, 1 año",
        "GUESTS": "Invitados",
        "GUESTS_YEAR": "Invitados, 12 meses",
        "CONNECTIONS": "Conexiones bancarias",
        "CONNECTIONS_YEAR": "Conexiones bancarias, 12 meses",
        "AI_USAGE": "Uso de IA este mes (monedero)",
        "AI_CREDIT": "Crédito mensual de IA",
        "flatAndUnit": "{{flat}} + {{unit}} cada uno",
        "subtotalMonth": "Suscripción, por mes",
        "subtotalYear": "Suscripción, por año",
        "aiNet": "IA pagada desde el monedero, por mes"
      }
    },
    "status": {
      "active": "Activo",
      "closed": "Cerrado",
      "draft": "Borrador"
    },
    "searchFailed": "No se pudieron buscar tarifarios; inténtalo de nuevo",
    "searching": "Buscando tarifarios",
    "publishRefusedNoField": "La versión {{version, number}} aún no se puede publicar.",
    "violations": {
      "summary_one": "Esta versión tiene {{count, number}} problema; la publicación se rechazará hasta que lo corrijas.",
      "summary_other": "Esta versión tiene {{count, number}} problemas; la publicación se rechazará hasta que los corrijas.",
      "chip_one": "{{count, number}} problema",
      "chip_other": "{{count, number}} problemas",
      "item": "{{label}}: {{message}}",
      "band": "{{section}}, banda {{n, number}}",
      "other": "Otro precio de esta versión",
      "summaryPublished_one": "Esta versión incumple {{count, number}} regla de publicación. Sigue vendiéndose; corrígela en una versión nueva.",
      "summaryPublished_other": "Esta versión incumple {{count, number}} reglas de publicación. Sigue vendiéndose; corrígelas en una versión nueva.",
      "checkValue": "Revisa este valor."
    }
  },
  "ledger": {
    "title": "Libro mayor",
    "notAvailable": "El libro mayor del socio aún no está disponible.",
    "loadError": "No se pudo cargar el libro mayor.",
    "payeeLoadError": "No se pudo leer el beneficiario de este socio.",
    "noPayee": "Este socio aún no está configurado como beneficiario.",
    "noPayeeLink": "Ver el estado del beneficiario",
    "loadMore": "Cargar más",
    "currency": "Moneda",
    "amount": {
      "label": "Importe",
      "invalid": "Escribe un importe mayor que cero, sin más decimales de los que tiene la moneda."
    },
    "reason": {
      "label": "Motivo",
      "help": "Se guarda en el registro de auditoría.",
      "length": "Usa de 3 a 500 caracteres."
    },
    "summary": {
      "title": "Saldo y retenciones",
      "balance": "Saldo:"
    },
    "holds": {
      "title": "Retenciones abiertas",
      "none": "No hay retenciones abiertas.",
      "overCap": "por encima del límite",
      "since": "desde el {{date}}"
    },
    "last": {
      "title": "Último extracto",
      "none": "Aún no se ha cerrado ningún extracto."
    },
    "statements": {
      "title": "Extractos",
      "empty": "Aún no hay extractos.",
      "loadError": "No se pudieron cargar los extractos.",
      "open": "Abrir extracto",
      "openRow": "Abrir el extracto de {{period}}",
      "col": {
        "period": "Periodo",
        "status": "Estado",
        "opening": "Apertura",
        "lines": "Líneas",
        "closing": "Cierre",
        "paid": "Pagado el",
        "actions": "Acciones"
      }
    },
    "statement": {
      "title": "Extracto de {{period}}",
      "titleLoading": "Extracto",
      "notFound": "Este extracto no está disponible.",
      "loadError": "No se pudo cargar el extracto.",
      "paidOn": "Pagado el {{date}}",
      "noLines": "Este extracto no tiene líneas.",
      "close": "Cerrar extracto"
    },
    "unassigned": {
      "title": "Líneas sin asignar",
      "help": "Líneas que ningún extracto ha tomado aún. El próximo extracto las toma.",
      "empty": "No hay líneas sin asignar."
    },
    "lines": {
      "loadError": "No se pudieron cargar las líneas.",
      "col": {
        "date": "Fecha",
        "kind": "Tipo",
        "description": "Descripción",
        "amount": "Importe"
      },
      "reverses": "Revierte la línea {{id}}"
    },
    "statementStatus": {
      "CARRIED": "Trasladado",
      "HELD": "En retención",
      "NEGATIVE": "Negativo",
      "PAYABLE": "Pagable",
      "PAYOUT_FAILED": "Pago fallido",
      "COLLECTING": "Cobrando",
      "PAYING": "Pagando",
      "PAID": "Pagado",
      "PAID_EXTERNALLY": "Pagado externamente",
      "COLLECTED": "Cobrado al socio",
      "SETTLED": "Liquidado"
    },
    "holdKind": {
      "FOR_CAUSE": "Por causa justificada",
      "REVIEW": "Revisión",
      "TAX_ID_UNVERIFIED": "ID fiscal sin verificar",
      "PAYOUT_RETURNED": "Pago devuelto",
      "OTHER": "Otra: {{kind}}",
      "COLLECTION_CONFLICT": "Conflicto de cobro"
    },
    "lineKind": {
      "REVENUE_SHARE": "Participación en ingresos",
      "MARGIN": "Margen",
      "AFFILIATE_COMMISSION": "Comisión de afiliado",
      "COMMISSION_DEDUCTION": "Deducción de comisión",
      "PROCESSING_FEE": "Comisión de procesamiento",
      "AFFILIATE_BONUS": "Bono de afiliado",
      "MINIMUM_SHORTFALL": "Déficit del mínimo",
      "ADJUSTMENT": "Ajuste",
      "REVERSAL": "Reversión",
      "VOID": "Anulación",
      "PAYOUT": "Pago",
      "PAYOUT_MANUAL": "Pago manual",
      "PAYOUT_RETURNED": "Pago devuelto",
      "COLLECTION": "Cobro"
    },
    "mode": {
      "OFF": "Desactivado",
      "SHADOW": "Sombra",
      "LIVE": "En vivo"
    },
    "hold": {
      "action": "Retener por causa…",
      "title": "¿Retener los pagos de {{name}} por causa justificada?",
      "words": "No se hace ningún pago mientras la retención esté abierta, y los extractos que cierren mientras tanto quedan retenidos. Libérala cuando se resuelva la causa.",
      "confirm": "Retener pagos",
      "failed": "No se pudo abrir la retención.",
      "done": "Pagos retenidos por causa justificada."
    },
    "release": {
      "action": "Liberar…",
      "title": "¿Liberar la retención «{{kind}}» de los pagos de {{name}}?",
      "words": "Los pagos que la retención detenía pueden hacerse de nuevo en el próximo pago.",
      "confirm": "Liberar retención",
      "failed": "No se pudo liberar la retención.",
      "opsOnly": "Solo el equipo de operaciones puede liberar esta retención; está en cola.",
      "notReleasable": "Esta retención no se puede liberar aquí: una revisión por encima del límite de transferencia la libera operaciones, y una retención por ID fiscal se levanta sola cuando se verifica el ID fiscal.",
      "done": "Retención liberada."
    },
    "void": {
      "action": "Anular…",
      "title": "¿Anular el saldo de {{name}}?",
      "words": "El saldo positivo del socio se anula y no se pagará. Las líneas ya pagadas no se tocan. No se puede deshacer. La retención sigue abierta hasta que la liberes.",
      "typeName": "Escribe {{name}} para confirmar",
      "confirm": "Anular saldo",
      "mismatch": "El nombre no coincide. Escribe el nombre del socio tal como aparece.",
      "failed": "No se pudo anular el saldo.",
      "done": "Saldo anulado."
    },
    "payment": {
      "action": "Registrar un pago manual…",
      "title": "Registrar un pago manual a {{name}}",
      "words": "Registra un pago hecho fuera de pay-api. El extracto queda marcado como pagado externamente.",
      "statement": "Extracto",
      "reference": "Como referencia: cierre",
      "balance": "saldo",
      "paidOn": "Pagado el",
      "paidOnRequired": "Escribe la fecha en que se pagó.",
      "referenceLabel": "Referencia del pago",
      "referenceRequired": "Escribe la referencia del pago.",
      "payableIs": "El importe pagable de este extracto es {{amount}}.",
      "notPayable": "Este importe no se puede pagar en este extracto. Puede ser como máximo el último cierre o el saldo, el que sea menor.",
      "confirm": "Registrar pago",
      "failed": "No se pudo registrar el pago.",
      "done": "Pago manual registrado."
    },
    "adjustment": {
      "action": "Registrar un ajuste…",
      "title": "Registrar un ajuste para {{name}}",
      "words": "Un ajuste corrige el saldo del socio. Sustituye a condonar un cargo y a marcarlo como cobrado.",
      "direction": "Sentido",
      "credit": "Abonar al socio (suma a su saldo)",
      "charge": "Cargar al socio (resta de su saldo)",
      "directionRequired": "Elige abono o cargo.",
      "continue": "Continuar",
      "back": "Atrás",
      "confirmCreditTitle": "¿Abonar {{amount}} a {{name}}?",
      "confirmChargeTitle": "¿Cargar {{amount}} a {{name}}?",
      "confirmCreditWords": "Esto suma {{amount}} al saldo de {{name}}. Se registra como ajuste y queda auditado.",
      "confirmChargeWords": "Esto resta {{amount}} del saldo de {{name}}. Se registra como ajuste y queda auditado.",
      "post": "Registrar ajuste",
      "failed": "No se pudo registrar el ajuste.",
      "done": "Ajuste registrado."
    },
    "frozen": {
      "banner": "Esto es historial de antes del libro mayor de socios.",
      "link": "Usa el libro mayor del socio.",
      "open": "Abrir el libro mayor"
    },
    "cutover": {
      "title": "Migración al libro mayor",
      "notAvailable": "La migración al libro mayor aún no está disponible.",
      "loadError": "No se pudo cargar la preparación de la migración.",
      "mode": "Modo del libro mayor: {{mode}}",
      "modeHelp": "Pasar a LIVE es un cambio de entorno del Operador en los dos wars de tmm-api.",
      "readiness": "Preparación",
      "passed": "Superada",
      "failing": "Sin cumplir",
      "failures": "Sin preparar: {{names}}",
      "refused": "Aún no: la preparación de arriba indica lo que falta.",
      "outbox": "Filas pendientes en la bandeja de salida: {{periods}}",
      "outboxNone": "No hay filas pendientes en la bandeja de salida.",
      "check": {
        "A2_CONFIRMED": "A2 de pay-api confirmada en producción",
        "OLD_STATEMENTS_SETTLED": "El último extracto antiguo generado y pagado",
        "PAYEES_READY": "Todos los socios configurados como beneficiarios",
        "OPENING_COMPUTED": "Ajustes de apertura calculados",
        "DEACTIVATION_WINDOWS_RESOLVED": "Ventanas de desactivación resueltas"
      },
      "checkHint": {
        "DEACTIVATION_WINDOWS_RESOLVED": "Las filas del libro mayor dentro de la ventana de desactivación de un revendedor se han reconstruido."
      },
      "notReadyYet": "Aún no está listo:",
      "failureKind": {
        "REFUND_OF_COVERED_SALE": "Un reembolso de una venta que la apertura ya cuenta.",
        "CLAWBACK": "Una comisión revertida.",
        "RECOVERY": "Una recuperación.",
        "UNPOSTED_PAYMENT": "Un pago que aún no se ha registrado.",
        "UNPOSTED_COMMISSION": "Una comisión que aún no se ha registrado.",
        "UNPOSTED_SHORTFALL": "Un déficit del mínimo que aún no se ha registrado.",
        "NETTING_ADDON": "Un complemento en descuento.",
        "SENT_BEFORE": "Enviado antes de la migración.",
        "MISMATCH": "La conciliación no cuadra.",
        "NO_PAYEE": "No hay un beneficiario configurado para este socio.",
        "OTHER_CURRENCY": "Una línea en otra moneda.",
        "TENANT_WITHOUT_RESELLER": "El tenant de este socio aún no tiene revendedor. Corrige el tenant y vuelve a ejecutar la vista previa."
      },
      "openingFailures": {
        "intro": "Para cada fila, registra un ajuste para ese socio y vuelve a ejecutar la vista previa.",
        "table": "Fallos de la comprobación de apertura",
        "col": {
          "partner": "Socio",
          "what": "Qué",
          "source": "Origen",
          "amount": "Importe"
        }
      },
      "a2": {
        "action": "Confirmar que A2 de pay-api está en producción…",
        "title": "¿Confirmar que A2 de pay-api está en producción?",
        "words": "Confirma solo cuando hayas comprobado que la versión A2 de pay-api está en producción. Queda auditado.",
        "confirm": "Confirmar A2",
        "failed": "No se pudo registrar la confirmación.",
        "done": "A2 de pay-api confirmada.",
        "recorded": "A2 de pay-api confirmada el {{when}}"
      },
      "freeze": {
        "action": "Congelar el sistema de pagos de tmm…",
        "title": "¿Congelar el sistema de pagos de tmm?",
        "words": "Se detienen las transferencias, el cierre y la ejecución de pagos, y el cobro de déficits y faltantes, con sus reintentos. No se borra nada. Repetirlo no cambia nada.",
        "confirm": "Congelar pagos",
        "failed": "No se pudo congelar el sistema de pagos.",
        "done": "Sistema de pagos congelado.",
        "recorded": "Sistema de pagos congelado el {{when}}"
      },
      "verticals": {
        "action": "Confirmar que tmm-api está en los verticales activos de pay-api…",
        "title": "¿Confirmar que tmm-api está en los verticales activos de pay-api?",
        "words": "Confirma solo cuando tmm-api esté en PAYAPI_SETTLEMENT_LIVE_VERTICALS en los dos wars de pay-api. tmm-api no puede leer ese ajuste. Queda auditado.",
        "confirm": "Confirmar verticales activos",
        "failed": "No se pudo registrar la confirmación.",
        "done": "Verticales activos confirmados.",
        "recorded": "Verticales activos confirmados el {{when}}"
      },
      "opening": {
        "title": "Ajustes de apertura",
        "help": "La apertura de cada socio es el saldo trasladado en el último extracto pagado de tmm. Revísala primero; no se registra nada hasta que la registres.",
        "preview": "Vista previa",
        "previewFailed": "No se pudo generar la vista previa de los ajustes de apertura.",
        "post": "Registrar los ajustes de apertura…",
        "confirmTitle": "¿Registrar los ajustes de apertura?",
        "confirmWords": "Se registra un ajuste de apertura por cada socio, por el importe que tmm-api calcula al registrarlo; la vista previa muestra esos importes a día de hoy. Queda auditado y se registra una sola vez.",
        "confirm": "Registrar ajustes",
        "failed": "No se pudieron registrar los ajustes de apertura.",
        "done": "Ajustes de apertura registrados.",
        "recorded": "Ajustes de apertura registrados el {{when}}",
        "posted": "Registrado.",
        "dryRun": "Solo vista previa: no se ha registrado nada.",
        "none": "Ningún socio tiene importe de apertura.",
        "matches": "Cuadra",
        "mismatch": "No cuadra",
        "col": {
          "partner": "Socio",
          "figure": "Apertura",
          "reconciliation": "Conciliación",
          "expected": "Sistema anterior",
          "ledger": "Libro mayor"
        }
      }
    }
  },
  "tickets": {
    "subtitle": "Casos de soporte, solicitudes de funciones y anuncios para los miembros de todos los tenants.",
    "tabsAria": "Secciones de soporte",
    "tab": {
      "support": "Casos de soporte",
      "features": "Solicitudes de funciones",
      "announcements": "Anuncios"
    },
    "filter": {
      "search": "Buscar tickets",
      "searchHint": "Busca en el título y la descripción",
      "status": "Estado",
      "allStatuses": "Todos los estados",
      "tenant": "Tenant",
      "allTenants": "Todos los tenants",
      "created": "Creado"
    },
    "created": {
      "ANY": "Cualquier fecha",
      "LAST_7_DAYS": "Últimos 7 días",
      "LAST_30_DAYS": "Últimos 30 días",
      "LAST_90_DAYS": "Últimos 90 días"
    },
    "loadError": "No se pudieron cargar los tickets.",
    "empty": {
      "support": "No hay casos de soporte.",
      "features": "No hay solicitudes de funciones."
    },
    "regionAria": "Lista de tickets",
    "col": {
      "number": "Número",
      "title": "Título",
      "tenant": "Tenant",
      "requester": "Solicitante",
      "status": "Estado",
      "followers": "Seguidores",
      "created": "Creado",
      "updated": "Actualizado"
    },
    "status": {
      "OPEN": "Abierto",
      "IN_PROGRESS": "En curso",
      "WAITING_ON_YOU": "Esperando al miembro",
      "RESOLVED": "Resuelto",
      "CLOSED": "Cerrado",
      "SUBMITTED": "Enviada",
      "UNDER_REVIEW": "En revisión",
      "PLANNED": "Planificada",
      "SHIPPED": "Publicada",
      "NOT_PLANNED": "No planificada",
      "DUPLICATE": "Duplicada"
    },
    "type": {
      "SUPPORT_CASE": "Caso de soporte",
      "FEATURE_REQUEST": "Solicitud de función"
    },
    "notAvailable": "Los tickets aún no están disponibles.",
    "notFound": "Este ticket no existe.",
    "ticket": "Ticket",
    "ticketLoadError": "No se pudo cargar este ticket.",
    "internalNote": "Nota interna: el miembro nunca la ve.",
    "composer": {
      "title": "Añadir a la conversación",
      "visibility": "Quién lo ve",
      "internal": "Nota interna",
      "public": "Responder al miembro",
      "publicWarning": "El miembro recibe esta respuesta por correo.",
      "noteLabel": "Nota",
      "replyLabel": "Respuesta",
      "counter": "{{used, number}} de {{max, number}} caracteres",
      "required": "Escribe algo para publicar.",
      "tooLong": "Como máximo {{max, number}} caracteres.",
      "postNote": "Publicar nota interna",
      "postReply": "Publicar respuesta al miembro",
      "error": "No se pudo publicar."
    },
    "changeStatus": {
      "action": "Cambiar estado…",
      "title": "Cambiar el estado de {{ticket}}",
      "current": "Ahora: {{status}}",
      "new": "Nuevo estado",
      "required": "Elige un estado.",
      "emailed": "El miembro recibe un correo sobre este cambio.",
      "confirm": "Cambiar estado",
      "conflict": "Ese estado no puede seguir a {{status}}.",
      "error": "No se pudo cambiar el estado."
    },
    "duplicate": {
      "action": "Marcar como duplicado…",
      "title": "Marcar {{ticket}} como duplicado",
      "canonical": "Duplicado de",
      "hint": "Busca por número o título",
      "noOptions": "No hay tickets que coincidan",
      "required": "Elige el ticket que duplica.",
      "consequence": "{{ticket}} apuntará a {{canonical}}; su solicitante sigue ese ticket.",
      "confirm": "Marcar como duplicado",
      "error": "No se pudo marcar como duplicado."
    },
    "shippedIn": {
      "action": "Indicar \"publicado en\"…",
      "title": "Indicar \"publicado en\" para {{ticket}}",
      "label": "Publicado en",
      "hint": "Una versión o lanzamiento, como texto libre. Déjalo vacío para borrarlo.",
      "confirm": "Guardar",
      "error": "No se pudo guardar \"publicado en\"."
    },
    "page": {
      "tabsAria": "Secciones del ticket",
      "conversation": "Conversación",
      "details": "Detalles"
    },
    "meta": {
      "requester": "Solicitado por {{person}}",
      "created": "Creado {{when}}",
      "updated": "Actualizado {{when}}",
      "followers_one": "{{count, number}} seguidor",
      "followers_other": "{{count, number}} seguidores",
      "shippedIn": "Publicado en {{shippedIn}}",
      "duplicateOf": "Duplicado de"
    },
    "conversation": {
      "empty": "Aún no hay actualizaciones.",
      "statusChanged": "Estado cambiado a {{status}}",
      "public": "Pública: el miembro la ve"
    },
    "author": {
      "MEMBER": "Miembro",
      "STAFF": "Personal",
      "SYSTEM": "Sistema"
    },
    "details": {
      "title": "Detalles",
      "description": "Descripción",
      "type": "Tipo",
      "email": "Correo electrónico",
      "origin": "Origen",
      "drafted": "Redactado con el asistente"
    },
    "attachments": {
      "title": "Adjuntos",
      "onUpdate": "Archivos adjuntos",
      "meta": "{{type}} · {{size}}",
      "download": "Descargar",
      "downloadAria": "Descargar {{name}}",
      "hint": "Los archivos solo se descargan; nunca se abren aquí.",
      "gone": "Este archivo ya no está disponible.",
      "error": "No se pudo descargar este archivo."
    }
  },
  "announcements": {
    "notAvailable": "Los anuncios aún no están disponibles.",
    "notFound": "Este anuncio no existe.",
    "loadError": "No se pudieron cargar los anuncios.",
    "itemLoadError": "No se pudo cargar este anuncio.",
    "new": "Nuevo anuncio",
    "empty": "Aún no hay anuncios.",
    "emptyFiltered": "Ningún anuncio coincide con estos filtros.",
    "regionAria": "Lista de anuncios",
    "filter": {
      "state": "Estado",
      "allStates": "Todos los estados",
      "kind": "Tipo",
      "allKinds": "Todos los tipos"
    },
    "col": {
      "title": "Título",
      "kind": "Tipo",
      "audience": "Público",
      "state": "Estado",
      "publishAt": "Se publica",
      "expiresAt": "Vence",
      "shownAs": "Se muestra como",
      "related": "Ticket relacionado",
      "reads": "Lecturas"
    },
    "audienceAll": "Todos los clientes",
    "audienceTenants_one": "{{count, number}} tenant",
    "audienceTenants_other": "{{count, number}} tenants",
    "pinned": "Fijado",
    "popup": "Ventana emergente",
    "kind": {
      "NEWS": "Novedades",
      "FEATURE": "Función nueva",
      "MAINTENANCE": "Mantenimiento",
      "IMPORTANT": "Importante"
    },
    "state": {
      "DRAFT": "Borrador",
      "SCHEDULED": "Programado",
      "PUBLISHED": "Publicado",
      "EXPIRED": "Expirado"
    },
    "editor": {
      "sectionContent": "Contenido",
      "sectionAudience": "Público y fechas",
      "sectionDisplay": "Presentación",
      "title": "Título",
      "titleRequired": "Escribe un título.",
      "body": "Texto",
      "bodyRequired": "Escribe el anuncio.",
      "bodyHint": "Markdown: # títulos, **negrita**, *cursiva*, listas y [enlaces](https://…). {productName} se convierte en el nombre del producto de cada cliente.",
      "bodyView": "Vista del texto",
      "edit": "Editar",
      "preview": "Vista previa",
      "previewEmpty": "Aún no hay nada que mostrar.",
      "previewNote": "Aquí {productName} se muestra tal cual; cada cliente ve el nombre de su producto.",
      "kind": "Tipo",
      "audience": "Público",
      "audienceChosen": "Tenants elegidos",
      "tenants": "Tenants",
      "tenantsHint": "Solo lo ven los miembros de estos tenants.",
      "tenantsRequired": "Elige al menos un tenant.",
      "tenantsLoadError": "No se pudieron cargar los tenants. Elige Todos los clientes o inténtalo más tarde.",
      "publishWhen": "Cuándo publicar",
      "schedule": "Programar",
      "publishAt": "Publicar el (tu hora)",
      "publishAtRequired": "Elige una fecha y una hora.",
      "publishAtPast": "Elige una hora futura o elige Ahora.",
      "expires": "Vence (opcional, tu hora)",
      "expiresHint": "Déjalo vacío para mantenerlo hasta que lo expires.",
      "expiresPast": "Elige una hora futura.",
      "expiresBeforePublish": "Elige una hora posterior a la publicación.",
      "pinned": "Fijar arriba",
      "pinnedHint": "Los anuncios fijados aparecen primero.",
      "popup": "Mostrar como ventana emergente",
      "popupWarning": "Se muestra una vez, como ventana emergente, a todo el público en su próxima visita.",
      "related": "Solicitud de función relacionada (opcional)",
      "relatedHint": "Sus seguidores ven este anuncio. Busca por número o título.",
      "noOptions": "No hay solicitudes de funciones que coincidan",
      "termRefused": "Menciona \"{{term}}\", que es interno. Quítalo para publicar.",
      "saveDraft": "Guardar borrador",
      "saved": "Borrador guardado.",
      "saveError": "No se pudo guardar el borrador.",
      "publishAction": "Publicar…",
      "scheduleAction": "Programar…",
      "readOnly": "Solo se puede editar un borrador. Primero retíralo para cambiarlo.",
      "expiredReadOnly": "Un anuncio expirado no se puede cambiar.",
      "details": "Detalles",
      "author": "Escrito por",
      "noExpiry": "Sin vencimiento",
      "notScheduled": "Sin programar"
    },
    "confirm": {
      "publishTitle": "¿Publicar \"{{title}}\"?",
      "scheduleTitle": "¿Programar \"{{title}}\"?",
      "whenNow": "Se publica ahora.",
      "whenAt": "Se publica el {{when}}.",
      "toAll": "Público: todos los clientes.",
      "toTenants_one": "Público: {{count, number}} tenant ({{names}}).",
      "toTenants_other": "Público: {{count, number}} tenants ({{names}}).",
      "popupYes": "Aparece una vez como ventana emergente para todo el público en su próxima visita.",
      "popupNo": "No aparece como ventana emergente: los miembros lo encuentran en su panel Soporte y funciones.",
      "expiresAt": "Vence el {{when}}.",
      "publish": "Publicar",
      "schedule": "Programar",
      "error": "No se pudo publicar.",
      "published": "Anuncio publicado.",
      "scheduled": "Anuncio programado."
    },
    "delete": {
      "action": "Eliminar borrador…",
      "title": "¿Eliminar el borrador \"{{title}}\"?",
      "consequence": "El borrador se elimina. No se puede deshacer.",
      "confirm": "Eliminar borrador",
      "done": "Borrador eliminado.",
      "error": "No se pudo eliminar el borrador."
    },
    "unpublish": {
      "action": "Retirar…",
      "title": "¿Retirar \"{{title}}\"?",
      "consequence": "Los miembros dejan de verlo y vuelve a ser un borrador que puedes editar.",
      "confirm": "Retirar",
      "done": "Anuncio retirado.",
      "error": "No se pudo retirar."
    },
    "expire": {
      "action": "Expirar ahora…",
      "title": "¿Expirar \"{{title}}\" ahora?",
      "consequence": "Los miembros dejan de verlo. Sigue en esta lista como expirado.",
      "confirm": "Expirar ahora",
      "done": "Anuncio expirado.",
      "error": "No se pudo expirar.",
      "notPublished": "Solo se puede expirar un anuncio publicado. {{stateWords}}",
      "nowState": {
        "DRAFT": "Este es un borrador.",
        "SCHEDULED": "Este está programado.",
        "PUBLISHED": "Este está publicado.",
        "EXPIRED": "Este ya expiró."
      }
    }
  },
  "knowledge": {
    "subtitle": "Nombres de comercios y bancos aprendidos de los miembros, compartidos solo cuando los apruebas.",
    "tabsAria": "Secciones de conocimiento de comercios",
    "tab": {
      "patterns": "Patrones de comercios",
      "banks": "Bancos no listados"
    },
    "notAvailable": {
      "patterns": "Los patrones de comercios aún no están disponibles.",
      "banks": "Los bancos no listados aún no están disponibles.",
      "naming": "La calidad de los nombres aún no está disponible."
    },
    "gate": {
      "NOT_P2P": "No es un pago entre personas",
      "MOSTLY_BUSINESS": "Confirmado mayormente como negocio",
      "MERCHANT_MARKERS": "Marcas de comercio",
      "NOT_PERSONAL_NAME": "No es un nombre de persona",
      "THRESHOLD": "Umbral alcanzado",
      "REDACTED": "Datos ocultos"
    },
    "gateResult": {
      "passed": "Cumplido",
      "notPassed": "No cumplido"
    },
    "gatesTally": "{{passed, number}} de {{total, number}}",
    "noProposedName": "Sin nombre propuesto",
    "stateNow": {
      "CANDIDATE": "Este patrón ahora es un candidato, así que eso no se puede hacer.",
      "APPROVED": "Este patrón ahora está aprobado, así que eso no se puede hacer.",
      "RETIRED": "Este patrón ahora está retirado, así que eso no se puede hacer."
    },
    "kind": {
      "VENDOR": "Negocio",
      "OTHER": "Otro",
      "PERSON": "Persona"
    },
    "institutionKind": {
      "BANK": "Banco",
      "CREDIT_UNION": "Cooperativa de crédito",
      "OTHER": "Otro"
    },
    "source": {
      "KNOWN_MERCHANT": "Comercios conocidos",
      "BANK_TEXT": "Texto del banco",
      "AI": "IA"
    },
    "view": {
      "aria": "Colas de patrones de comercios",
      "ready": "Listos para revisar",
      "short": "Aún incompletos",
      "approved": "Aprobados",
      "retired": "Retirados"
    },
    "search": "Buscar patrones",
    "searchHint": "Busca en el patrón y en el nombre propuesto",
    "loadError": "No se pudieron cargar los patrones de comercios.",
    "regionAria": "Lista de patrones de comercios",
    "empty": {
      "ready": "No hay candidatos listos para revisar.",
      "short": "No hay candidatos incompletos.",
      "approved": "No hay patrones aprobados.",
      "retired": "No hay patrones retirados."
    },
    "col": {
      "pattern": "Patrón",
      "proposedName": "Nombre propuesto",
      "kind": "Tipo",
      "confirmations": "Confirmaciones",
      "edits": "Ediciones",
      "forgets": "Olvidos",
      "members": "Miembros",
      "tenants": "Tenants",
      "gates": "Controles cumplidos",
      "actions": "Acciones"
    },
    "detail": {
      "open": "Abrir",
      "pattern": "Patrón",
      "kind": "Tipo",
      "evidence": "Evidencia",
      "gates": "Controles",
      "noGates": "No se enviaron resultados de los controles."
    },
    "approve": {
      "open": "Aprobar…",
      "title": "Aprobar un patrón de comercio",
      "name": "Nombre",
      "nameHint": "Corrige la ortografía si hace falta.",
      "nameRequired": "Escribe un nombre.",
      "kind": "Tipo",
      "kindRequired": "Elige un tipo.",
      "consequence": "Los miembros cuyo texto bancario coincida con este patrón lo verán con el nombre «{{name}}» ({{kind}}).",
      "error": "No se pudo aprobar el patrón.",
      "notPromotable": "Este patrón aún no se puede aprobar. No pasa: {{gates}}.",
      "confirm": "Aprobar",
      "done": "Patrón aprobado."
    },
    "reject": {
      "open": "Rechazar…",
      "title": "Rechazar «{{name}}»",
      "reason": "Motivo",
      "hint": "Se guarda con el registro de auditoría. Los miembros nunca lo ven. {{used, number}} de {{max, number}} caracteres.",
      "required": "Escribe un motivo.",
      "tooLong": "Usa {{max, number}} caracteres o menos.",
      "error": "No se pudo rechazar el patrón.",
      "confirm": "Rechazar",
      "done": "Patrón rechazado."
    },
    "retire": {
      "open": "Retirar…",
      "title": "¿Retirar «{{name}}»?",
      "consequence": "Los nombres de los miembros dejan de usar este patrón, y pasa a Retirados.",
      "confirm": "Retirar",
      "error": "No se pudo retirar el patrón.",
      "done": "Patrón retirado."
    },
    "banks": {
      "loadError": "No se pudieron cargar los bancos no listados.",
      "empty": "No hay bancos no listados que revisar.",
      "regionAria": "Lista de bancos no listados",
      "newest": "Se muestran las {{max, number}} más recientes.",
      "requests_one": "{{count, number}} solicitud",
      "requests_other": "{{count, number}} solicitudes",
      "col": {
        "typedName": "Nombre escrito",
        "country": "País",
        "count": "Solicitudes",
        "requestedAt": "Última solicitud"
      },
      "add": {
        "open": "Añadir al catálogo…",
        "title": "Añadir «{{name}}» al catálogo",
        "name": "Nombre",
        "nameHint": "Tal como deben verlo los miembros.",
        "nameRequired": "Escribe un nombre.",
        "country": "País",
        "countryInvalid": "Escribe el código de país de dos letras, como CR o US.",
        "city": "Ciudad (opcional)",
        "kind": "Tipo",
        "kindRequired": "Elige un tipo.",
        "error": "No se pudo añadir el banco al catálogo.",
        "confirm": "Añadir al catálogo",
        "done": "{{name}} añadido al catálogo.",
        "exists": "Ya está en la lista. Hay un banco con este nombre en el catálogo de {{country}}. Descarta esta solicitud en vez de añadirlo.",
        "dismissInstead": "Descartar solicitud"
      },
      "dismiss": {
        "open": "Descartar…",
        "title": "¿Descartar «{{name}}»?",
        "consequence_one": "Se cierra la solicitud de {{country}}. No se añade nada al catálogo.",
        "consequence_other": "Se cierran las {{count, number}} solicitudes de {{country}}. No se añade nada al catálogo.",
        "confirm": "Descartar",
        "error": "No se pudo descartar la solicitud.",
        "done": "Solicitud descartada."
      }
    }
  },
  "namingQuality": {
    "intro": "¿Mejoran los nombres? Con qué frecuencia los miembros aceptan, editan u olvidan los nombres que reciben.",
    "noInstitution": "Sin banco del catálogo",
    "loadError": "No se pudo cargar el informe de calidad de los nombres.",
    "empty": "No hay nombres en este periodo.",
    "by": {
      "aria": "Secciones de calidad de los nombres",
      "source": "Por origen del nombre",
      "institution": "Por institución",
      "model": "Por modelo y versión del prompt"
    },
    "col": {
      "source": "Origen del nombre",
      "institution": "Institución",
      "model": "Modelo",
      "promptVersion": "Versión del prompt",
      "named": "Nombres",
      "accepted": "Aceptados",
      "edited": "Editados",
      "forgotten": "Olvidados",
      "acceptanceRate": "Tasa de aceptación",
      "editRate": "Tasa de edición",
      "forgetRate": "Tasa de olvido"
    }
  }
}
